// This file is auto-generated by scripts/generate-emojis.mjs! Do not modify it directly.
export const emojiKeywords = {
  100: '100 hundred points score perfect numbers century exam quiz test pass full keep symbol',
  grinning: 'grinning face smile happy joy d grin smiley',
  smiley: 'smiley grinning face with big eyes happy joy haha d smile funny mouth open smiling',
  smile: 'smile grinning face with smiling eyes happy joy funny haha laugh like d eye grin mouth open pleased smiley',
  grin: 'grin beaming face with smiling eyes happy smile joy kawaii eye grinning',
  laughing: 'laughing grinning squinting face happy joy lol satisfied haha glad xd laugh big closed eyes grin mouth open smile smiling tightly',
  sweat_smile: 'sweat smile grinning face with hot happy laugh relief cold exercise mouth open smiling',
  rofl: 'rofl rolling on the floor laughing face lol haha laugh rotfl',
  joy: 'joy face with tears of cry weep happy happytears haha crying laugh laughing lol tear',
  slightly_smiling_face: 'slightly smiling face smile fine happy this',
  upside_down_face: 'upside down face flipped silly smile sarcasm',
  wink: 'wink winking face happy mischievous secret smile eye flirt winky',
  blush: 'blush smiling face with eyes smile happy flushed crush embarrassed shy joy eye proud smiley',
  innocent: 'innocent smiling face with halo angel heaven fairy fantasy smile tale',
  smiling_face_with_three_hearts: 'smiling face with three hearts love like affection valentines infatuation crush adore eyes',
  heart_eyes: 'heart eyes smiling face with love like affection valentines infatuation crush eye shaped smile',
  star_struck: 'star struck face smile starry eyes grinning excited eyed wow',
  kissing_heart: 'kissing heart face blowing a kiss love like affection valentines infatuation blow flirt throwing',
  kissing: 'kissing face love like 3 valentines infatuation kiss duck kissy whistling',
  relaxed: 'relaxed smiling face blush massage happiness happy outlined pleased smile smiley white',
  kissing_closed_eyes: 'kissing closed eyes face with love like affection valentines infatuation kiss eye kissy',
  kissing_smiling_eyes: 'kissing smiling eyes face with affection valentines infatuation kiss eye kissy smile whistle whistling',
  smiling_face_with_tear: 'smiling face with tear sad cry pretend grateful happy proud relieved smile touched',
  yum: 'yum face savoring food happy joy tongue smile silly yummy nom delicious savouring goofy hungry lick licking lips smiling um',
  stuck_out_tongue: 'stuck out tongue face with prank childish playful mischievous smile cheeky',
  stuck_out_tongue_winking_eye: 'stuck out tongue winking eye face with prank childish playful mischievous smile wink crazy joke silly',
  zany_face: 'zany face goofy crazy excited eye eyes grinning large one small wacky wild',
  stuck_out_tongue_closed_eyes: 'stuck out tongue closed eyes squinting face with prank playful mischievous smile eye horrible taste tightly',
  money_mouth_face: 'money mouth face rich dollar eyes sign',
  hugs: 'hugs smiling face with open hands hugging smile hug',
  hand_over_mouth: 'hand over mouth face with whoops shock surprise blushing covering eyes quiet smiling',
  shushing_face: 'shushing face quiet shhh closed covering finger hush lips shh shush silence',
  thinking: 'thinking face hmmm think consider chin shade thinker throwing thumb',
  zipper_mouth_face: 'zipper mouth face sealed secret hush lips silence zip',
  raised_eyebrow: 'raised eyebrow face with distrust scepticism disapproval disbelief surprise suspicious colbert mild one rock skeptic',
  neutral_face: 'neutral face indifference meh deadpan faced mouth straight',
  expressionless: 'expressionless face indifferent meh deadpan inexpressive mouth straight unexpressive',
  no_mouth: 'no mouth face without blank mouthless mute quiet silence silent',
  smirk: 'smirk smirking face smile mean prank smug sarcasm flirting sexual suggestive',
  unamused: 'unamused face indifference bored straight serious sarcasm unimpressed skeptical dubious ugh side eye dissatisfied meh unhappy',
  roll_eyes: 'roll eyes face with rolling eyeroll frustrated eye',
  grimacing: 'grimacing face grimace teeth awkward eek nervous',
  lying_face: 'lying face lie pinocchio liar long nose',
  relieved: 'relieved face relaxed phew massage happiness content pleased whew',
  pensive: 'pensive face sad depressed upset dejected sadface sorrowful',
  sleepy: 'sleepy face tired rest nap bubble side sleep snot tear',
  drooling_face: 'drooling face drool',
  sleeping: 'sleeping face tired sleepy night zzz sleep snoring',
  mask: 'mask face with medical sick ill disease covid cold coronavirus doctor medicine surgical',
  face_with_thermometer: 'face with thermometer sick temperature cold fever covid ill',
  face_with_head_bandage: 'face with head bandage injured clumsy hurt bandaged injury',
  nauseated_face: 'nauseated face vomit gross green sick throw up ill barf disgust disgusted',
  vomiting_face: 'vomiting face sick barf ill mouth open puke spew throwing up vomit',
  sneezing_face: 'sneezing face gesundheit sneeze sick allergy achoo',
  hot_face: 'hot face feverish heat red sweating overheated stroke',
  cold_face: 'cold face blue freezing frozen frostbite icicles ice',
  woozy_face: 'woozy face dizzy intoxicated tipsy wavy drunk eyes groggy mouth uneven',
  dizzy_face: 'dizzy face with crossed out eyes spent unconscious xox cross dead knocked spiral',
  cowboy_hat_face: 'cowboy hat face cowgirl',
  partying_face: 'partying face celebration woohoo birthday hat horn party',
  disguised_face: 'disguised face pretent brows glasses moustache disguise incognito nose',
  sunglasses: 'sunglasses smiling face with cool smile summer beach sunglass best bright eye eyewear friends glasses mutual snapchat sun weather',
  nerd_face: 'nerd face nerdy geek dork glasses smiling',
  monocle_face: 'monocle face with stuffy wealthy rich exploration inspection',
  confused: 'confused face indifference huh weird hmmm meh nonplussed puzzled s',
  worried: 'worried face concern nervous sad sadface',
  slightly_frowning_face: 'slightly frowning face disappointed sad upset frown unhappy',
  frowning_face: 'frowning face sad upset frown megafrown unhappy white',
  open_mouth: 'open mouth face with surprise impressed wow whoa o surprised sympathy',
  hushed: 'hushed face woo shh silence speechless stunned surprise surprised',
  astonished: 'astonished face xox surprised poisoned amazed drunk gasp gasping shocked totally',
  flushed: 'flushed face blush shy flattered blushing dazed embarrassed eyes open shame wide',
  pleading_face: 'pleading face begging mercy cry tears sad grievance eyes glossy puppy simp',
  anguished: 'anguished face stunned nervous pained',
  fearful: 'fearful face scared terrified nervous fear oops shocked surprised',
  cold_sweat: 'cold sweat anxious face with nervous blue concerned mouth open rushed',
  disappointed_relieved: 'disappointed relieved sad but face phew sweat nervous eyebrow whew',
  cry: 'cry crying face tears sad depressed upset tear',
  sob: 'sob loudly crying face sobbing cry tears sad upset depressed bawling tear',
  scream: 'scream face screaming in fear munch scared omg alone fearful home horror shocked',
  confounded: 'confounded face confused sick unwell oops s mouth quivering scrunched',
  persevere: 'persevere persevering face sick no upset oops eyes helpless scrunched struggling',
  disappointed: 'disappointed face sad upset depressed sadface',
  sweat: 'sweat downcast face with hot sad tired exercise cold hard work',
  weary: 'weary face tired sleepy sad frustrated upset distraught wailing',
  tired_face: 'tired face sick whine upset frustrated distraught exhausted fed up',
  yawning_face: 'yawning face tired sleepy bored yawn',
  triumph: 'triumph face with steam from nose gas phew proud pride airing frustrated grievances look mad smug steaming won',
  pout: 'pout enraged face pouting angry mad hate despise grumpy rage red',
  angry: 'angry face mad annoyed frustrated anger grumpy',
  cursing_face: 'cursing face with symbols on mouth swearing cussing profanity expletive covering foul grawlix over serious',
  smiling_imp: 'smiling imp face with horns devil evil fairy fantasy happy purple red smile tale',
  imp: 'imp angry face with horns devil demon evil fairy fantasy goblin purple sad tale',
  skull: 'skull dead skeleton creepy death body danger face fairy grey halloween monster poison tale',
  skull_and_crossbones: 'skull and crossbones poison danger deadly scary death pirate evil body face halloween monster',
  hankey: 'hankey pile of poo shitface fail turd shit comic crap dirt dog dung face monster poop smiling bad needs improvement',
  clown_face: 'clown face mock',
  japanese_ogre: 'japanese ogre monster red mask halloween scary creepy devil demon creature face fairy fantasy oni tale shrek',
  japanese_goblin: 'japanese goblin red evil mask monster scary creepy creature face fairy fantasy long nose tale tengu',
  ghost: 'ghost halloween spooky scary creature disappear face fairy fantasy ghoul monster tale',
  alien: 'alien ufo paul weird outer space creature et extraterrestrial face fairy fantasy monster tale external',
  space_invader: 'space invader alien monster game arcade play creature extraterrestrial face fairy fantasy retro tale ufo video',
  robot: 'robot computer machine bot face monster',
  smiley_cat: 'smiley cat grinning animal cats happy smile face mouth open smiling',
  smile_cat: 'smile cat grinning with smiling eyes animal cats eye face grin happy',
  joy_cat: 'joy cat with tears of animal cats haha happy face laughing tear',
  heart_eyes_cat: 'heart eyes cat smiling with animal love like affection cats valentines eye face loving shaped smile',
  smirk_cat: 'smirk cat with wry smile animal cats face ironic smirking',
  kissing_cat: 'kissing cat animal cats kiss closed eye eyes face',
  scream_cat: 'scream cat weary animal cats munch scared face fear horror oh screaming surprised',
  crying_cat_face: 'crying cat face animal tears weep sad cats upset cry tear',
  pouting_cat: 'pouting cat animal cats face grumpy',
  see_no_evil: 'see no evil monkey animal nature haha blind covering eyes face forbidden gesture ignore mizaru not prohibited',
  hear_no_evil: 'hear no evil monkey animal nature covering deaf ears face forbidden gesture kikazaru not prohibited',
  speak_no_evil: 'speak no evil monkey animal nature omg covering face forbidden gesture hush iwazaru mouth mute not speaking prohibited ignore',
  kiss: 'kiss mark face lips love like affection valentines heart kissing lipstick romance',
  love_letter: 'love letter email like affection envelope valentines heart mail note romance',
  cupid: 'cupid heart with arrow love like affection valentines lovestruck romance',
  gift_heart: 'gift heart with ribbon love valentines box chocolate chocolates valentine',
  sparkling_heart: 'sparkling heart love like affection valentines excited sparkle sparkly stars',
  heartpulse: 'heartpulse growing heart like love affection valentines pink excited multiple nervous pulse triple',
  heartbeat: 'heartbeat beating heart love like affection valentines pink alarm pulsating wifi',
  revolving_hearts: 'revolving hearts love like affection valentines heart two',
  two_hearts: 'two hearts love like affection valentines heart pink small',
  heart_decoration: 'heart decoration purple square love like',
  heavy_heart_exclamation: 'heavy heart exclamation decoration love above an as dot mark ornament punctuation red',
  broken_heart: 'broken heart sad sorry break heartbreak breaking brokenhearted',
  heart: 'heart red love like valentines black heavy',
  orange_heart: 'orange heart love like affection valentines',
  yellow_heart: 'yellow heart love like affection valentines bf gold snapchat',
  green_heart: 'green heart love like affection valentines nct',
  blue_heart: 'blue heart love like affection valentines brand neutral',
  purple_heart: 'purple heart love like affection valentines bts emoji',
  brown_heart: 'brown heart coffee',
  black_heart: 'black heart evil dark wicked',
  white_heart: 'white heart pure',
  anger: 'anger symbol angry mad comic pop sign vein',
  boom: 'boom collision bomb explode explosion blown bang comic impact red spark symbol break',
  dizzy: 'dizzy star sparkle shoot magic circle comic symbol animations transitions',
  sweat_drops: 'sweat drops droplets water drip oops comic plewds splashing symbol workout',
  dash: 'dash dashing away wind air fast shoo fart smoke puff blow comic gust running steam symbol vaping',
  hole: 'hole embarrassing',
  bomb: 'bomb boom explode explosion terrorism comic',
  speech_balloon: 'speech balloon bubble words message talk chatting chat comic comment dialog text literals',
  eye_speech_bubble: 'eye speech bubble in info am i witness',
  left_speech_bubble: 'left speech bubble words message talk chatting dialog',
  right_anger_bubble: 'right anger bubble caption speech thinking mad angry balloon zag zig',
  thought_balloon: 'thought balloon bubble cloud speech thinking dream comic',
  zzz: 'zzz sleepy tired dream bedtime boring comic sign sleep sleeping symbol',
  wave: 'wave waving hand hands gesture goodbye solong farewell hello hi palm body sign',
  raised_back_of_hand: 'raised back of hand fingers backhand body',
  raised_hand_with_fingers_splayed: 'raised hand with fingers splayed palm body finger five',
  hand: 'hand raised fingers stop highfive palm ban body five high',
  vulcan_salute: 'vulcan salute hand fingers spock star trek between body finger middle part prosper raised ring split',
  ok_hand: 'ok hand fingers limbs perfect okay body sign',
  pinched_fingers: 'pinched fingers size tiny small che finger gesture hand interrogation ma purse sarcastic vuoi',
  pinching_hand: 'pinching hand tiny small size amount body little',
  v: 'v victory hand fingers ohyeah peace two air body quotes sign',
  crossed_fingers: 'crossed fingers good lucky body cross finger hand hopeful index luck middle',
  love_you_gesture: 'love you gesture hand fingers body i ily sign',
  metal: 'metal sign of the horns hand fingers evil eye rock on body devil finger heavy',
  call_me_hand: 'call me hand hands gesture shaka body phone sign',
  point_left: 'point left backhand index pointing direction fingers hand body finger white',
  point_right: 'point right backhand index pointing fingers hand direction body finger white',
  point_up_2: 'point up 2 backhand index pointing fingers hand direction body finger middle white',
  fu: 'fu middle finger hand fingers rude flipping bird body dito extended medio reversed',
  point_down: 'point down backhand index pointing fingers hand direction body finger white',
  point_up: 'point up index pointing hand fingers direction body finger secret white',
  '+1': '+1 thumbs up thumbsup yes awesome good agree accept cool hand like approve body ok sign thumb',
  '-1': '1 thumbs down thumbsdown no dislike hand bad body bury disapprove sign thumb',
  fist: 'fist raised fingers hand grasp body clenched power pump punch',
  facepunch: 'facepunch oncoming fist angry violence hit attack hand body bro brofist bump clenched closed fisted punch sign',
  fist_left: 'fist left facing hand fistbump body bump leftwards',
  fist_right: 'fist right facing hand fistbump body bump rightwards',
  clap: 'clap clapping hands praise applause congrats yay body golf hand round sign',
  raised_hands: 'raised hands raising gesture hooray yea celebration air arms banzai body both festivus hallelujah hand miracle person praise two',
  open_hands: 'open hands fingers butterfly body hand hug jazz sign',
  palms_up_together: 'palms up together hands gesture cupped prayer body dua facing',
  handshake: 'handshake agreement shake deal hand hands meeting shaking',
  pray: 'pray folded hands please hope wish namaste highfive thank you thanks appreciate ask body bow five gesture hand high person prayer pressed together',
  writing_hand: 'writing hand lower left ballpoint pen stationery write compose body',
  nail_care: 'nail care polish beauty manicure finger fashion slay body cosmetics fingers nonchalant',
  selfie: 'selfie camera phone arm hand',
  muscle: 'muscle flexed biceps arm flex hand summer strong bicep body comic feats flexing muscles strength workout',
  mechanical_arm: 'mechanical arm accessibility body prosthetic',
  mechanical_leg: 'mechanical leg accessibility body prosthetic',
  leg: 'leg kick limb body',
  foot: 'foot kick stomp body',
  ear: 'ear face hear sound listen body ears hearing listening nose',
  ear_with_hearing_aid: 'ear with hearing aid accessibility body hard',
  nose: 'nose smell sniff body smelling sniffing stinky',
  brain: 'brain smart intelligent body organ',
  anatomical_heart: 'anatomical heart health heartbeat cardiology organ pulse',
  lungs: 'lungs breathe breath exhalation inhalation organ respiration',
  tooth: 'tooth teeth dentist body',
  bone: 'bone skeleton body',
  eyes: 'eyes look watch stalk peek see body eye eyeballs face shifty wide',
  eye: 'eye face look see watch stare body single',
  tongue: 'tongue mouth playful body out taste',
  lips: 'lips mouth kiss body kissing',
  baby: 'baby child boy girl toddler newborn young',
  child: 'child gender neutral young boy girl inclusive person unspecified',
  boy: 'boy man male guy teenager child young',
  girl: 'girl female woman teenager child maiden virgin virgo young zodiac',
  adult: 'adult person gender neutral female inclusive male man men unspecified woman women',
  blond_haired_person: 'blond haired person hair hairstyle blonde man',
  man: 'man mustache father dad guy classy sir moustache adult male men',
  bearded_person: 'bearded person beard man bewhiskered',
  red_haired_man: 'red haired man hair hairstyle adult ginger male men redhead',
  curly_haired_man: 'curly haired man hair hairstyle adult male men',
  white_haired_man: 'white haired man hair old elder adult male men',
  bald_man: 'bald man hairless adult hair male men no',
  woman: 'woman female girls lady adult women yellow',
  red_haired_woman: 'red haired woman hair hairstyle adult female ginger redhead women',
  person_red_hair: 'person red hair hairstyle adult gender haired unspecified',
  curly_haired_woman: 'curly haired woman hair hairstyle adult female women',
  person_curly_hair: 'person curly hair hairstyle adult gender haired unspecified',
  white_haired_woman: 'white haired woman hair old elder adult female women',
  person_white_hair: 'person white hair elder old adult gender haired unspecified',
  bald_woman: 'bald woman hairless adult female hair no women',
  person_bald: 'person bald hairless adult gender hair no unspecified',
  blond_haired_woman: 'blond haired woman hair female girl blonde person women',
  blond_haired_man: 'blond haired man hair male boy blonde guy person men',
  older_adult: 'older adult person human elder senior gender neutral female male man men old unspecified woman women',
  older_man: 'older man old human male men elder senior adult elderly grandpa',
  older_woman: 'older woman old human female women lady elder senior adult elderly grandma nanna',
  frowning_person: 'frowning person worried frown gesture sad woman',
  frowning_man: 'frowning man male boy sad depressed discouraged unhappy frown gesture men',
  frowning_woman: 'frowning woman female girl sad depressed discouraged unhappy frown gesture women',
  pouting_face: 'pouting face person upset blank fed gesture look up',
  pouting_man: 'pouting man male boy gesture men',
  pouting_woman: 'pouting woman female girl gesture women',
  no_good: 'no good person gesturing decline arms deal denied face forbidden gesture halt hand not ok prohibited stop x',
  ng_man: 'ng man gesturing no male boy nope denied forbidden gesture good halt hand men not ok prohibited stop',
  ng_woman: 'ng woman gesturing no female girl nope denied forbidden gesture good halt hand not ok prohibited stop women',
  ok_person: 'ok person gesturing agree ballerina face gesture hand hands head',
  ok_man: 'ok man gesturing men boy male blue human gesture hand',
  ok_woman: 'ok woman gesturing women girl female pink human gesture hand',
  information_desk_person: 'information desk person tipping hand attendant bellhop concierge female flick girl hair help sassy woman women',
  sassy_man: 'sassy man tipping hand male boy human information desk help men',
  sassy_woman: 'sassy woman tipping hand female girl human information desk help women',
  raising_hand: 'raising hand person question answering gesture happy one raised up',
  raising_hand_man: 'raising hand man male boy gesture happy men one raised',
  raising_hand_woman: 'raising hand woman female girl gesture happy one raised women',
  deaf_person: 'deaf person accessibility ear hear',
  deaf_man: 'deaf man accessibility male men',
  deaf_woman: 'deaf woman accessibility female women',
  bow: 'bow person bowing respectiful apology boy cute deeply dogeza gesture man massage respect sorry thanks',
  bowing_man: 'bowing man male boy apology bow deeply favor gesture men respect sorry thanks',
  bowing_woman: 'bowing woman female girl apology bow deeply favor gesture respect sorry thanks women',
  facepalm: 'facepalm person facepalming disappointed disbelief exasperation face head hitting palm picard smh',
  man_facepalming: 'man facepalming male boy disbelief exasperation face facepalm men palm',
  woman_facepalming: 'woman facepalming female girl disbelief exasperation face facepalm palm women',
  shrug: 'shrug person shrugging regardless doubt ignorance indifference shruggie',
  man_shrugging: 'man shrugging male boy confused indifferent doubt ignorance indifference men shrug',
  woman_shrugging: 'woman shrugging female girl confused indifferent doubt ignorance indifference shrug women',
  health_worker: 'health worker hospital dentist doctor healthcare md nurse physician professional therapist',
  man_health_worker: 'man health worker doctor nurse therapist healthcare human dentist male md men physician professional',
  woman_health_worker: 'woman health worker doctor nurse therapist healthcare human dentist female md physician professional women',
  student: 'student learn education graduate pupil school',
  man_student: 'man student graduate human education graduation male men pupil school',
  woman_student: 'woman student graduate human education female graduation pupil school women',
  teacher: 'teacher professor education educator instructor',
  man_teacher: 'man teacher instructor professor human education educator male men school',
  woman_teacher: 'woman teacher instructor professor human education educator female school women',
  judge: 'judge law court justice scales',
  man_judge: 'man judge justice court human law male men scales',
  woman_judge: 'woman judge justice court human female law scales women',
  farmer: 'farmer crops farm farming gardener rancher worker',
  man_farmer: 'man farmer rancher gardener human farm farming male men worker',
  woman_farmer: 'woman farmer rancher gardener human farm farming female women worker',
  cook: 'cook food kitchen culinary chef cooking service',
  man_cook: 'man cook chef human cooking food male men service',
  woman_cook: 'woman cook chef human cooking female food service women',
  mechanic: 'mechanic worker technician electrician person plumber repair tradesperson',
  man_mechanic: 'man mechanic plumber human wrench electrician male men person repair tradesperson',
  woman_mechanic: 'woman mechanic plumber human wrench electrician female person repair tradesperson women',
  factory_worker: 'factory worker labor assembly industrial welder',
  man_factory_worker: 'man factory worker assembly industrial human male men welder',
  woman_factory_worker: 'woman factory worker assembly industrial human female welder women',
  office_worker: 'office worker business accountant adviser analyst architect banker clerk manager',
  man_office_worker: 'man office worker business manager human accountant adviser analyst architect banker businessman ceo clerk male men',
  woman_office_worker: 'woman office worker business manager human accountant adviser analyst architect banker businesswoman ceo clerk female women',
  scientist: 'scientist chemistry biologist chemist engineer lab mathematician physicist technician',
  man_scientist: 'man scientist biologist chemist engineer physicist human lab male mathematician men research technician',
  woman_scientist: 'woman scientist biologist chemist engineer physicist human female lab mathematician research technician women',
  technologist: 'technologist computer coder engineer laptop software technology developer',
  man_technologist: 'man technologist coder developer engineer programmer software human laptop computer blogger male men technology',
  woman_technologist: 'woman technologist coder developer engineer programmer software human laptop computer blogger female technology women',
  singer: 'singer song artist performer actor entertainer music musician rock rocker rockstar star',
  man_singer: 'man singer rockstar entertainer human actor aladdin bowie male men music musician rock rocker sane star',
  woman_singer: 'woman singer rockstar entertainer human actor female music musician rock rocker star women',
  artist: 'artist painting draw creativity art paint painter palette',
  man_artist: 'man artist painter human art male men paint palette',
  woman_artist: 'woman artist painter human art female paint palette women',
  pilot: 'pilot fly plane airplane aviation aviator',
  man_pilot: 'man pilot aviator plane human airplane aviation male men',
  woman_pilot: 'woman pilot aviator plane human airplane aviation female women',
  astronaut: 'astronaut outerspace moon planets rocket space stars',
  man_astronaut: 'man astronaut space rocket human cosmonaut male men moon planets stars',
  woman_astronaut: 'woman astronaut space rocket human cosmonaut female moon planets stars women',
  firefighter: 'firefighter fire firetruck',
  man_firefighter: 'man firefighter fireman human fire firetruck male men',
  woman_firefighter: 'woman firefighter fireman human female fire firetruck women',
  cop: 'cop police officer law policeman policewoman',
  policeman: 'policeman man police officer law legal enforcement arrest 911 cop male men',
  policewoman: 'policewoman woman police officer law legal enforcement arrest 911 female cop women',
  detective: 'detective human spy eye or private sleuth',
  male_detective: 'male detective man crime men sleuth spy',
  female_detective: 'female detective woman human spy sleuth women',
  guard: 'guard protect british guardsman',
  guardsman: 'guardsman man guard uk gb british male guy royal men',
  guardswoman: 'guardswoman woman guard uk gb british female royal guardsman women',
  ninja: 'ninja ninjutsu skills japanese fighter hidden stealth',
  construction_worker: 'construction worker labor build builder face hard hat helmet safety add ci update',
  construction_worker_man: 'construction worker man male human wip guy build labor helmet men',
  construction_worker_woman: 'construction worker woman female human wip build labor helmet women',
  prince: 'prince boy man male crown royal king fairy fantasy men tale',
  princess: 'princess girl woman female blond crown royal queen blonde fairy fantasy tale tiara women',
  person_with_turban: 'person with turban wearing headdress arab man muslim sikh',
  man_with_turban: 'man with turban wearing male indian hinduism arabs men',
  woman_with_turban: 'woman with turban wearing female indian hinduism arabs women',
  man_with_gua_pi_mao: 'man with gua pi mao person skullcap male boy chinese asian cap hat',
  woman_with_headscarf: 'woman with headscarf female hijab mantilla tichel',
  person_in_tuxedo: 'person in tuxedo man couple marriage wedding groom male men suit',
  man_in_tuxedo: 'man in tuxedo formal fashion groom male men person suit wedding',
  woman_in_tuxedo: 'woman in tuxedo formal fashion female wedding women',
  person_with_veil: 'person with veil bride couple marriage wedding woman',
  man_with_veil: 'man with veil wedding marriage bride male men',
  bride_with_veil: 'bride with veil woman wedding marriage female women',
  pregnant_woman: 'pregnant woman baby female pregnancy lady women',
  breast_feeding: 'breast feeding nursing baby breastfeeding child female infant milk mother woman women',
  woman_feeding_baby: 'woman feeding baby birth food bottle child female infant milk nursing women',
  man_feeding_baby: 'man feeding baby birth food bottle child infant male men milk nursing',
  person_feeding_baby: 'person feeding baby birth food bottle child infant milk nursing',
  angel: 'angel baby heaven wings halo cherub cupid face fairy fantasy putto tale',
  santa: 'santa claus festival man male xmas father christmas activity celebration men nicholas saint sinterklaas',
  mrs_claus: 'mrs claus woman female xmas mother christmas activity celebration santa women',
  mx_claus: 'mx claus christmas activity celebration santa',
  superhero: 'superhero marvel fantasy good hero heroine superpower superpowers',
  superhero_man: 'superhero man male good hero superpowers fantasy men superpower',
  superhero_woman: 'superhero woman female good heroine superpowers fantasy hero superpower women',
  supervillain: 'supervillain marvel bad criminal evil fantasy superpower superpowers villain',
  supervillain_man: 'supervillain man male evil bad criminal hero superpowers fantasy men superpower villain',
  supervillain_woman: 'supervillain woman female evil bad criminal heroine superpowers fantasy superpower villain women',
  mage: 'mage magic fantasy sorcerer sorceress witch wizard',
  mage_man: 'mage man male sorcerer fantasy men wizard',
  mage_woman: 'mage woman female witch fantasy sorceress wizard women',
  fairy: 'fairy wings magical fantasy oberon puck titania',
  fairy_man: 'fairy man male fantasy men oberon puck',
  fairy_woman: 'fairy woman female fantasy titania wings women',
  vampire: 'vampire blood twilight dracula fantasy undead',
  vampire_man: 'vampire man male dracula fantasy men undead',
  vampire_woman: 'vampire woman female fantasy undead unded women',
  merperson: 'merperson sea fantasy merboy mergirl mermaid merman merwoman',
  merman: 'merman man male triton fantasy men mermaid',
  mermaid: 'mermaid woman female merwoman ariel fantasy women',
  elf: 'elf magical ears fantasy legolas pointed',
  elf_man: 'elf man male ears fantasy magical men pointed',
  elf_woman: 'elf woman female ears fantasy magical pointed women',
  genie: 'genie magical wishes djinn djinni fantasy jinni',
  genie_man: 'genie man male djinn fantasy men',
  genie_woman: 'genie woman female djinn fantasy women',
  zombie: 'zombie dead fantasy undead walking',
  zombie_man: 'zombie man male dracula undead walking dead fantasy men',
  zombie_woman: 'zombie woman female undead walking dead fantasy women',
  massage: 'massage person getting relax face head massaging salon spa',
  massage_man: 'massage man getting male boy head face men salon spa',
  massage_woman: 'massage woman getting female girl head face salon spa women',
  haircut: 'haircut person getting hairstyle barber beauty cutting hair hairdresser parlor',
  haircut_man: 'haircut man getting male boy barber beauty men parlor',
  haircut_woman: 'haircut woman getting female girl barber beauty parlor women',
  walking: 'walking person move hike pedestrian walk walker',
  walking_man: 'walking man human feet steps hike male men pedestrian walk',
  walking_woman: 'walking woman human feet steps female hike pedestrian walk women',
  standing_person: 'standing person still stand',
  standing_man: 'standing man still male men stand',
  standing_woman: 'standing woman still female stand women',
  kneeling_person: 'kneeling person pray respectful kneel',
  kneeling_man: 'kneeling man pray respectful kneel male men',
  kneeling_woman: 'kneeling woman respectful pray female kneel women',
  person_with_probing_cane: 'person with probing cane white blind accessibility',
  man_with_probing_cane: 'man with probing cane white blind accessibility male men',
  woman_with_probing_cane: 'woman with probing cane white blind accessibility female women',
  person_in_motorized_wheelchair: 'person in motorized wheelchair disability accessibility',
  man_in_motorized_wheelchair: 'man in motorized wheelchair disability accessibility male men',
  woman_in_motorized_wheelchair: 'woman in motorized wheelchair disability accessibility female women',
  person_in_manual_wheelchair: 'person in manual wheelchair disability accessibility',
  man_in_manual_wheelchair: 'man in manual wheelchair disability accessibility male men',
  woman_in_manual_wheelchair: 'woman in manual wheelchair disability accessibility female women',
  runner: 'runner person running move exercise jogging marathon run workout',
  running_man: 'running man walking exercise race male marathon men racing runner workout',
  running_woman: 'running woman walking exercise race female boy marathon racing runner women workout',
  dancer: 'dancer woman dancing female girl fun dance dress red salsa women',
  man_dancing: 'man dancing male boy fun dancer dance disco men',
  business_suit_levitating: 'business suit levitating person in man levitate hover jump boy hovering jabsco male men rude walt',
  dancers: 'dancers people with bunny ears perform costume dancer dancing ear partying wearing women',
  dancing_men: 'dancing men with bunny ears male boys dancer ear man partying wearing',
  dancing_women: 'dancing women with bunny ears female girls dancer ear partying people wearing',
  sauna_person: 'sauna person in steamy room relax spa hamam steam steambath',
  sauna_man: 'sauna man in steamy room male spa steamroom hamam men steam steambath',
  sauna_woman: 'sauna woman in steamy room female spa steamroom hamam steam steambath women',
  climbing: 'climbing person sport bouldering climber rock',
  climbing_man: 'climbing man sports hobby male rock bouldering climber men',
  climbing_woman: 'climbing woman sports hobby female rock bouldering climber women',
  person_fencing: 'person fencing sports sword fencer',
  horse_racing: 'horse racing animal betting competition gambling luck jockey race racehorse',
  skier: 'skier sports winter snow ski',
  snowboarder: 'snowboarder sports winter ski snow snowboard snowboarding',
  golfing: 'golfing person sports business ball club golf golfer',
  golfing_man: 'golfing man sport ball golf golfer male men',
  golfing_woman: 'golfing woman sports business female ball golf golfer women',
  surfer: 'surfer person surfing sport sea surf',
  surfing_man: 'surfing man sports ocean sea summer beach male men surfer',
  surfing_woman: 'surfing woman sports ocean sea summer beach female surfer women',
  rowboat: 'rowboat person rowing boat sport move paddles vehicle',
  rowing_man: 'rowing man boat sports hobby water ship male men rowboat vehicle',
  rowing_woman: 'rowing woman boat sports hobby water ship female rowboat vehicle women',
  swimmer: 'swimmer person swimming sport pool swim',
  swimming_man: 'swimming man sports exercise human athlete water summer male men swim swimmer',
  swimming_woman: 'swimming woman sports exercise human athlete water summer female swim swimmer women',
  bouncing_ball_person: 'bouncing ball person sports human basketball player',
  basketball_man: 'basketball man bouncing ball sport male men player',
  basketball_woman: 'basketball woman bouncing ball sports human female player women',
  weight_lifting: 'weight lifting person weights sports training exercise bodybuilder gym lifter weightlifter workout',
  weight_lifting_man: 'weight lifting man weights sport gym lifter male men weightlifter workout',
  weight_lifting_woman: 'weight lifting woman weights sports training exercise female gym lifter weightlifter women workout',
  bicyclist: 'bicyclist person biking bicycle bike cyclist sport move',
  biking_man: 'biking man bicycle bike cyclist sports exercise hipster bicyclist male men',
  biking_woman: 'biking woman bicycle bike cyclist sports exercise hipster female bicyclist women',
  mountain_bicyclist: 'mountain bicyclist person biking bicycle bike cyclist sport move biker',
  mountain_biking_man: 'mountain biking man bicycle bike cyclist transportation sports human race bicyclist biker male men',
  mountain_biking_woman: 'mountain biking woman bicycle bike cyclist transportation sports human race female bicyclist biker women',
  cartwheeling: 'cartwheeling person sport gymnastic cartwheel doing gymnast gymnastics',
  man_cartwheeling: 'man cartwheeling gymnastics cartwheel doing male men',
  woman_cartwheeling: 'woman cartwheeling gymnastics cartwheel doing female women',
  wrestling: 'wrestling people sport wrestle wrestler wrestlers',
  men_wrestling: 'men wrestling sports wrestlers male man wrestle wrestler',
  women_wrestling: 'women wrestling sports wrestlers female woman wrestle wrestler',
  water_polo: 'water polo person playing sport',
  man_playing_water_polo: 'man playing water polo sports pool male men',
  woman_playing_water_polo: 'woman playing water polo sports pool female women',
  handball_person: 'handball person playing sport ball',
  man_playing_handball: 'man playing handball sports ball male men',
  woman_playing_handball: 'woman playing handball sports ball female women',
  juggling_person: 'juggling person performance balance juggle juggler multitask skill',
  man_juggling: 'man juggling juggle balance skill multitask juggler male men',
  woman_juggling: 'woman juggling juggle balance skill multitask female juggler women',
  lotus_position: 'lotus position person in meditate meditation serenity yoga',
  lotus_position_man: 'lotus position man in male meditation yoga serenity zen mindfulness men',
  lotus_position_woman: 'lotus position woman in female meditation yoga serenity zen mindfulness women',
  bath: 'bath person taking clean shower bathroom bathing bathtub hot',
  sleeping_bed: 'sleeping bed person in rest accommodation hotel sleep',
  people_holding_hands: 'people holding hands friendship couple date gender hand hold inclusive neutral nonconforming',
  two_women_holding_hands: 'two women holding hands pair friendship couple love like female people human date hand hold lesbian lgbt pride woman',
  couple: 'couple woman and man holding hands pair people human love date dating like affection valentines marriage female hand heterosexual hold male men straight women',
  two_men_holding_hands: 'two men holding hands pair couple love like bromance friendship people human date gay hand hold lgbt male man pride',
  couplekiss: 'couplekiss kiss pair valentines love like dating marriage couple female gender heart kissing male man men neutral romance woman women',
  couplekiss_man_woman: 'couplekiss man woman kiss love couple female heart kissing male men romance women',
  couplekiss_man_man: 'couplekiss man kiss pair valentines love like dating marriage couple gay heart kissing lgbt male men pride romance two',
  couplekiss_woman_woman: 'couplekiss woman kiss pair valentines love like dating marriage couple female heart kissing lesbian lgbt pride romance two women',
  couple_with_heart: 'couple with heart pair love like affection human dating valentines marriage female gender loving male man men neutral romance woman women',
  couple_with_heart_woman_man: 'couple with heart woman man love female male men romance women',
  couple_with_heart_man_man: 'couple with heart man pair love like affection human dating valentines marriage gay lgbt male men pride romance two',
  couple_with_heart_woman_woman: 'couple with heart woman pair love like affection human dating valentines marriage female lesbian lgbt pride romance two women',
  family: 'family home parents child mom dad father mother people human boy female male man men woman women',
  family_man_woman_boy: 'family man woman boy love father mother son',
  family_man_woman_girl: 'family man woman girl home parents people human child daughter father female male men mother women',
  family_man_woman_girl_boy: 'family man woman girl boy home parents people human children child daughter father female male men mother son women',
  family_man_woman_boy_boy: 'family man woman boy home parents people human children child father female male men mother sons two women',
  family_man_woman_girl_girl: 'family man woman girl home parents people human children child daughters father female male men mother two women',
  family_man_man_boy: 'family man boy home parents people human children child father fathers gay lgbt male men pride son two',
  family_man_man_girl: 'family man girl home parents people human children child daughter father fathers gay lgbt male men pride two',
  family_man_man_girl_boy: 'family man girl boy home parents people human children child daughter father fathers gay lgbt male men pride son two',
  family_man_man_boy_boy: 'family man boy home parents people human children child father fathers gay lgbt male men pride sons two',
  family_man_man_girl_girl: 'family man girl home parents people human children child daughters father fathers gay lgbt male men pride two',
  family_woman_woman_boy: 'family woman boy home parents people human children child female lesbian lgbt mother mothers pride son two women',
  family_woman_woman_girl: 'family woman girl home parents people human children child daughter female lesbian lgbt mother mothers pride two women',
  family_woman_woman_girl_boy: 'family woman girl boy home parents people human children child daughter female lesbian lgbt mother mothers pride son two women',
  family_woman_woman_boy_boy: 'family woman boy home parents people human children child female lesbian lgbt mother mothers pride sons two women',
  family_woman_woman_girl_girl: 'family woman girl home parents people human children child daughters female lesbian lgbt mother mothers pride two women',
  family_man_boy: 'family man boy home parent people human child father male men son',
  family_man_boy_boy: 'family man boy home parent people human children child father male men sons two',
  family_man_girl: 'family man girl home parent people human child daughter father female male',
  family_man_girl_boy: 'family man girl boy home parent people human children child daughter father male men son',
  family_man_girl_girl: 'family man girl home parent people human children child daughters father female male two',
  family_woman_boy: 'family woman boy home parent people human child female mother son women',
  family_woman_boy_boy: 'family woman boy home parent people human children child female mother sons two women',
  family_woman_girl: 'family woman girl home parent people human child daughter female mother women',
  family_woman_girl_boy: 'family woman girl boy home parent people human children child daughter female male mother son',
  family_woman_girl_girl: 'family woman girl home parent people human children child daughters female mother two women',
  speaking_head: 'speaking head user person human sing say talk face mansplaining shout shouting silhouette speak',
  bust_in_silhouette: 'bust in silhouette user person human shadow',
  busts_in_silhouette: 'busts in silhouette user person human group team bust people shadows silhouettes two users contributors',
  people_hugging: 'people hugging care goodbye hello hug thanks',
  footprints: 'footprints feet tracking walking beach body clothing footprint footsteps print tracks',
  exploding_head: 'exploding head face shocked mind blown blowing explosion mad',
  frowning_face_with_open_mouth: 'frowning face with open mouth aw what frown yawning',
  face_in_clouds: 'face in clouds shower steam dream absentminded brain fog forgetful haze head impractical unrealistic',
  face_exhaling: 'face exhaling relieve relief tired sigh exhale gasp groan whisper whistle',
  face_with_spiral_eyes: 'face with spiral eyes sick ill confused nauseous nausea dizzy hypnotized trouble whoa',
  heart_on_fire: 'heart on fire passionate enthusiastic burn love lust sacred',
  mending_heart: 'mending heart broken bandage wounded bandaged healing healthier improving recovering recuperating unbroken well',
  man_beard: 'man beard facial hair bearded bewhiskered male men',
  woman_beard: 'woman beard facial hair bearded bewhiskered female women',
  melting_face: 'melting face hot heat disappear dissolve dread liquid melt sarcasm',
  face_with_open_eyes_and_hand_over_mouth: 'face with open eyes and hand over mouth silence secret shock surprise amazement awe disbelief embarrass gasp scared',
  face_with_peeking_eye: 'face with peeking eye scared frightening embarrassing shy captivated peep stare',
  saluting_face: 'saluting face respect salute ok sunny troops yes',
  dotted_line_face: 'dotted line face invisible lonely isolation depression depressed disappear hide introvert',
  face_with_diagonal_mouth: 'face with diagonal mouth skeptic confuse frustrated indifferent confused disappointed meh skeptical unsure',
  face_holding_back_tears: 'face holding back tears touched gratitude cry angry proud resist sad',
  rightwards_hand: 'rightwards hand palm offer right rightward',
  leftwards_hand: 'leftwards hand palm offer left leftward',
  palm_down_hand: 'palm down hand drop dismiss shoo',
  palm_up_hand: 'palm up hand lift offer demand beckon catch come',
  hand_with_index_finger_and_thumb_crossed: 'hand with index finger and thumb crossed heart love money expensive snap',
  index_pointing_at_the_viewer: 'index pointing at the viewer you recruit point',
  heart_hands: 'heart hands love appreciation support',
  biting_lip: 'biting lip flirt sexy pain worry anxious fear flirting nervous uncomfortable worried',
  person_with_crown: 'person with crown royalty power monarch noble regal',
  pregnant_man: 'pregnant man baby belly bloated full',
  pregnant_person: 'pregnant person baby belly bloated full',
  troll: 'troll mystical monster fairy fantasy tale shrek',
  shaking_face: 'shaking face dizzy shock blurry earthquake',
  pink_heart: 'pink heart valentines',
  light_blue_heart: 'light blue heart ice baby',
  grey_heart: 'grey heart silver monochrome',
  leftwards_pushing_hand: 'leftwards pushing hand highfive pressing stop',
  rightwards_pushing_hand: 'rightwards pushing hand highfive pressing stop',
  head_shaking_horizontally: 'head shaking horizontally disapprove indiffernt left',
  head_shaking_vertically: 'head shaking vertically down nod',
  family_adult_adult_child: 'family adult child kid parents',
  family_adult_adult_child_child: 'family adult child children parents',
  family_adult_child: 'family adult child parent kid',
  family_adult_child_child: 'family adult child parent children',
  monkey_face: 'monkey face animal nature circus head',
  monkey: 'monkey animal nature banana circus cheeky',
  gorilla: 'gorilla animal nature circus',
  orangutan: 'orangutan animal ape',
  dog: 'dog face animal friend nature woof puppy pet faithful',
  dog2: 'dog2 dog animal nature friend doge pet faithful doggo',
  guide_dog: 'guide dog animal blind accessibility eye seeing',
  service_dog: 'service dog blind animal accessibility assistance',
  poodle: 'poodle dog animal 101 nature pet miniature standard toy',
  wolf: 'wolf animal nature wild face',
  fox_face: 'fox face animal nature',
  raccoon: 'raccoon animal nature curious face sly',
  cat: 'cat face animal meow nature pet kitten kitty',
  cat2: 'cat2 cat animal meow pet cats domestic feline housecat',
  black_cat: 'black cat superstition luck halloween pet unlucky',
  lion: 'lion animal nature face leo zodiac',
  tiger: 'tiger face animal cat danger wild nature roar cute',
  tiger2: 'tiger2 tiger animal nature roar bengal',
  leopard: 'leopard animal nature african jaguar',
  horse: 'horse face animal brown nature head',
  racehorse: 'racehorse horse animal gamble luck equestrian galloping racing speed',
  unicorn: 'unicorn animal nature mystical face',
  zebra: 'zebra animal nature stripes safari face stripe',
  deer: 'deer animal nature horns venison buck reindeer stag',
  bison: 'bison ox buffalo herd wisent',
  cow: 'cow face beef ox animal nature moo milk happy',
  ox: 'ox animal cow beef bull bullock oxen steer taurus zodiac',
  water_buffalo: 'water buffalo animal nature ox cow domestic',
  cow2: 'cow2 cow beef ox animal nature moo milk dairy',
  pig: 'pig face animal oink nature head',
  pig2: 'pig2 pig animal nature hog sow',
  boar: 'boar animal nature pig warthog wild',
  pig_nose: 'pig nose animal oink face snout',
  ram: 'ram animal sheep nature aries male zodiac',
  sheep: 'sheep ewe animal nature wool shipit female lamb',
  goat: 'goat animal nature capricorn zodiac',
  dromedary_camel: 'dromedary camel animal hot desert hump arabian bump one',
  camel: 'camel two hump animal nature hot desert asian bactrian bump',
  llama: 'llama animal nature alpaca guanaco vicu a wool',
  giraffe: 'giraffe animal nature spots safari face',
  elephant: 'elephant animal nature nose th circus',
  mammoth: 'mammoth elephant tusks extinct extinction large tusk woolly',
  rhinoceros: 'rhinoceros animal nature horn rhino',
  hippopotamus: 'hippopotamus animal nature hippo',
  mouse: 'mouse face animal nature cheese wedge rodent',
  mouse2: 'mouse2 mouse animal nature rodent dormouse mice',
  rat: 'rat animal mouse rodent',
  hamster: 'hamster animal nature face pet',
  rabbit: 'rabbit face animal nature pet spring magic bunny easter',
  rabbit2: 'rabbit2 rabbit animal nature pet magic spring bunny',
  chipmunk: 'chipmunk animal nature rodent squirrel',
  beaver: 'beaver animal rodent dam',
  hedgehog: 'hedgehog animal nature spiny face',
  bat: 'bat animal nature blind vampire batman',
  bear: 'bear animal nature wild face teddy',
  polar_bear: 'polar bear animal arctic face white',
  koala: 'koala animal nature bear face marsupial',
  panda_face: 'panda face animal nature',
  sloth: 'sloth animal lazy slow',
  otter: 'otter animal fishing playful',
  skunk: 'skunk animal smelly stink',
  kangaroo: 'kangaroo animal nature australia joey hop marsupial jump roo',
  badger: 'badger animal nature honey pester',
  feet: 'feet paw prints animal tracking footprints dog cat pet kitten print puppy',
  turkey: 'turkey animal bird thanksgiving wild',
  chicken: 'chicken animal cluck nature bird hen',
  rooster: 'rooster animal nature chicken bird cock cockerel',
  hatching_chick: 'hatching chick animal chicken egg born baby bird',
  baby_chick: 'baby chick animal chicken bird yellow',
  hatched_chick: 'hatched chick front facing baby animal chicken bird standing',
  bird: 'bird animal nature fly tweet spring',
  penguin: 'penguin animal nature bird',
  dove: 'dove animal bird fly peace',
  eagle: 'eagle animal nature bird bald',
  duck: 'duck animal nature bird mallard',
  swan: 'swan animal nature bird cygnet duckling ugly',
  owl: 'owl animal nature bird hoot wise',
  dodo: 'dodo animal bird extinct extinction large mauritius obsolete',
  feather: 'feather bird fly flight light plumage',
  flamingo: 'flamingo animal flamboyant tropical',
  peacock: 'peacock animal nature peahen bird ostentatious proud',
  parrot: 'parrot animal nature bird pirate talk',
  frog: 'frog animal nature croak toad face',
  crocodile: 'crocodile animal nature reptile lizard alligator croc',
  turtle: 'turtle animal slow nature tortoise terrapin',
  lizard: 'lizard animal nature reptile gecko',
  snake: 'snake animal evil nature hiss python bearer ophiuchus serpent zodiac',
  dragon_face: 'dragon face animal myth nature chinese green fairy head tale',
  dragon: 'dragon animal myth nature chinese green fairy tale',
  sauropod: 'sauropod animal nature dinosaur brachiosaurus brontosaurus diplodocus extinct',
  't-rex': 't rex animal nature dinosaur tyrannosaurus extinct trex',
  whale: 'whale spouting animal nature sea ocean cute face',
  whale2: 'whale2 whale animal nature sea ocean',
  dolphin: 'dolphin animal nature fish sea ocean flipper fins beach',
  seal: 'seal animal creature sea lion',
  fish: 'fish animal food nature freshwater pisces zodiac',
  tropical_fish: 'tropical fish animal swim ocean beach nemo blue yellow',
  blowfish: 'blowfish animal nature food sea ocean fish fugu pufferfish',
  shark: 'shark animal nature fish sea ocean jaws fins beach great white',
  octopus: 'octopus animal creature ocean sea nature beach',
  shell: 'shell spiral nature sea beach seashell',
  snail: 'snail slow animal shell garden slug',
  butterfly: 'butterfly animal insect nature caterpillar pretty',
  bug: 'bug animal insect nature worm caterpillar',
  ant: 'ant animal insect nature bug',
  bee: 'bee honeybee animal insect nature bug spring honey bumblebee',
  beetle: 'beetle insect bug',
  lady_beetle: 'lady beetle animal insect nature ladybug bug ladybird',
  cricket: 'cricket animal chirp grasshopper insect orthoptera',
  cockroach: 'cockroach insect pests pest roach',
  spider: 'spider animal arachnid insect',
  spider_web: 'spider web animal insect arachnid silk cobweb spiderweb',
  scorpion: 'scorpion animal arachnid scorpio scorpius zodiac',
  mosquito: 'mosquito animal nature insect malaria disease fever pest virus',
  fly: 'fly insect disease maggot pest rotting',
  worm: 'worm animal annelid earthworm parasite',
  microbe: 'microbe amoeba bacteria germs virus covid cell coronavirus germ microorganism',
  bouquet: 'bouquet flowers nature spring flower plant romance',
  cherry_blossom: 'cherry blossom nature plant spring flower pink sakura',
  white_flower: 'white flower japanese spring blossom cherry doily done paper stamp well',
  rosette: 'rosette flower decoration military plant',
  rose: 'rose flowers valentines love spring flower plant red',
  wilted_flower: 'wilted flower plant nature rose dead drooping',
  hibiscus: 'hibiscus plant vegetable flowers beach flower',
  sunflower: 'sunflower nature plant fall flower sun yellow',
  blossom: 'blossom nature flowers yellow blossoming flower daisy plant',
  tulip: 'tulip flowers plant nature summer spring flower',
  seedling: 'seedling plant nature grass lawn spring sprout sprouting young seed',
  potted_plant: 'potted plant greenery house boring grow houseplant nurturing useless',
  evergreen_tree: 'evergreen tree plant nature fir pine wood',
  deciduous_tree: 'deciduous tree plant nature rounded shedding wood',
  palm_tree: 'palm tree plant vegetable nature summer beach mojito tropical coconut',
  cactus: 'cactus vegetable plant nature desert',
  ear_of_rice: 'ear of rice sheaf nature plant crop farming grain wheat',
  herb: 'herb vegetable plant medicine weed grass lawn crop leaf',
  shamrock: 'shamrock vegetable plant nature irish clover trefoil',
  four_leaf_clover: 'four leaf clover vegetable plant nature lucky irish ireland luck',
  maple_leaf: 'maple leaf nature plant vegetable ca fall canada canadian falling',
  fallen_leaf: 'fallen leaf nature plant vegetable leaves autumn brown fall falling',
  leaves: 'leaves leaf fluttering in wind nature plant tree vegetable grass lawn spring blow flutter green',
  coral: 'coral ocean sea reef',
  lotus: 'lotus flower calm meditation buddhism hinduism india purity vietnam',
  empty_nest: 'empty nest bird nesting',
  nest_with_eggs: 'nest with eggs bird nesting',
  moose: 'moose canada sweden sven cool',
  donkey: 'donkey eeyore mule',
  wing: 'wing angel birds flying fly',
  black_bird: 'black bird crow',
  goose: 'goose silly jemima goosebumps honk',
  jellyfish: 'jellyfish sting tentacles',
  hyacinth: 'hyacinth flower lavender',
  phoenix: 'phoenix immortal bird mythtical reborn',
  grapes: 'grapes fruit food wine grape plant',
  melon: 'melon fruit nature food cantaloupe honeydew muskmelon plant',
  watermelon: 'watermelon fruit food picnic summer plant',
  mandarin: 'mandarin tangerine food fruit nature orange plant',
  lemon: 'lemon fruit nature citrus lemonade plant',
  banana: 'banana fruit food monkey plant plantain',
  pineapple: 'pineapple fruit nature food plant',
  mango: 'mango fruit food tropical',
  apple: 'apple red fruit mac school delicious plant',
  green_apple: 'green apple fruit nature delicious golden granny plant smith',
  pear: 'pear fruit nature food plant',
  peach: 'peach fruit nature food bottom butt plant',
  cherries: 'cherries food fruit berries cherry plant red wild',
  strawberry: 'strawberry fruit food nature berry plant',
  blueberries: 'blueberries fruit berry bilberry blue blueberry',
  kiwi_fruit: 'kiwi fruit food chinese gooseberry kiwifruit',
  tomato: 'tomato fruit vegetable nature food plant',
  olive: 'olive fruit food olives',
  coconut: 'coconut fruit nature food palm cocoanut colada pi a',
  avocado: 'avocado fruit food',
  eggplant: 'eggplant vegetable nature food aubergine phallic plant purple',
  potato: 'potato food tuber vegatable starch baked idaho vegetable',
  carrot: 'carrot vegetable food orange',
  corn: 'corn ear of food vegetable plant cob maize maze',
  hot_pepper: 'hot pepper food spicy chilli chili plant',
  bell_pepper: 'bell pepper fruit plant capsicum vegetable',
  cucumber: 'cucumber fruit food pickle gherkin vegetable',
  leafy_green: 'leafy green food vegetable plant bok choy cabbage kale lettuce chinese cos greens romaine',
  broccoli: 'broccoli fruit food vegetable cabbage wild',
  garlic: 'garlic food spice cook flavoring plant vegetable',
  onion: 'onion cook food spice flavoring plant vegetable',
  mushroom: 'mushroom plant vegetable fungus shroom toadstool',
  peanuts: 'peanuts food nut nuts peanut vegetable',
  chestnut: 'chestnut food squirrel acorn nut plant',
  bread: 'bread food wheat breakfast toast loaf',
  croissant: 'croissant food bread french breakfast crescent roll',
  baguette_bread: 'baguette bread food french france bakery',
  flatbread: 'flatbread flour food bakery arepa bread flat lavash naan pita',
  pretzel: 'pretzel food bread twisted germany bakery soft twist',
  bagel: 'bagel food bread bakery schmear jewish breakfast cheese cream',
  pancakes: 'pancakes food breakfast flapjacks hotcakes brunch cr pe pes hotcake pancake',
  waffle: 'waffle food breakfast brunch indecisive iron',
  cheese: 'cheese wedge food chadder swiss',
  meat_on_bone: 'meat on bone good food drumstick barbecue bbq manga',
  poultry_leg: 'poultry leg food meat drumstick bird chicken turkey bone',
  cut_of_meat: 'cut of meat food cow chop lambchop porkchop steak',
  bacon: 'bacon food breakfast pork pig meat brunch rashers',
  hamburger: 'hamburger meat fast food beef cheeseburger mcdonalds burger king',
  fries: 'fries french chips snack fast food potato mcdonald s',
  pizza: 'pizza food party italy cheese pepperoni slice',
  hotdog: 'hotdog hot dog food frankfurter america redhot sausage wiener',
  sandwich: 'sandwich food lunch bread toast bakery cheese deli meat vegetables',
  taco: 'taco food mexican',
  burrito: 'burrito food mexican wrap',
  tamale: 'tamale food masa mexican tamal wrapped',
  stuffed_flatbread: 'stuffed flatbread food gyro mediterranean doner falafel kebab pita sandwich shawarma',
  falafel: 'falafel food mediterranean chickpea falfel meatball',
  egg: 'egg food chicken breakfast easter',
  fried_egg: 'fried egg cooking food breakfast kitchen skillet frying pan',
  shallow_pan_of_food: 'shallow pan of food cooking casserole paella skillet curry',
  stew: 'stew pot of food meat soup hot bowl',
  fondue: 'fondue cheese pot food chocolate melted swiss',
  bowl_with_spoon: 'bowl with spoon food breakfast cereal oatmeal porridge congee tableware',
  green_salad: 'green salad food healthy lettuce vegetable',
  popcorn: 'popcorn food movie theater films snack drama corn popping',
  butter: 'butter food cook dairy',
  salt: 'salt condiment shaker',
  canned_food: 'canned food soup tomatoes can preserve tin tinned',
  bento: 'bento box food japanese lunch assets',
  rice_cracker: 'rice cracker food japanese snack senbei',
  rice_ball: 'rice ball food japanese onigiri omusubi',
  rice: 'rice cooked food asian boiled bowl steamed',
  curry: 'curry rice food spicy hot indian',
  ramen: 'ramen steaming bowl food japanese noodle chopsticks noodles soup',
  spaghetti: 'spaghetti food italian pasta noodle',
  sweet_potato: 'sweet potato roasted food nature plant goguma yam',
  oden: 'oden skewer food japanese kebab seafood stick',
  sushi: 'sushi food fish japanese rice sashimi seafood',
  fried_shrimp: 'fried shrimp food animal appetizer summer prawn tempura',
  fish_cake: 'fish cake with swirl food japan sea beach narutomaki pink kamaboko surimi ramen design fishcake pastry',
  moon_cake: 'moon cake food autumn dessert festival mooncake yu b ng',
  dango: 'dango food dessert sweet japanese barbecue meat balls green pink skewer stick white',
  dumpling: 'dumpling food empanada pierogi potsticker gyoza gy za jiaozi',
  fortune_cookie: 'fortune cookie food prophecy dessert',
  takeout_box: 'takeout box food leftovers chinese container out oyster pail take',
  crab: 'crab animal crustacean cancer zodiac',
  lobster: 'lobster animal nature bisque claws seafood',
  shrimp: 'shrimp animal ocean nature seafood food prawn shellfish small',
  squid: 'squid animal nature ocean sea food molusc',
  oyster: 'oyster food diving pearl',
  icecream: 'icecream soft ice cream food hot dessert summer mr serve sweet whippy',
  shaved_ice: 'shaved ice hot dessert summer cone snow sweet',
  ice_cream: 'ice cream food hot dessert bowl sweet',
  doughnut: 'doughnut food dessert snack sweet donut breakfast',
  cookie: 'cookie food snack oreo chocolate sweet dessert biscuit chip',
  birthday: 'birthday cake food dessert candles celebration party pastry sweet',
  cake: 'cake shortcake food dessert pastry piece slice strawberry sweet',
  cupcake: 'cupcake food dessert bakery sweet cake fairy pastry',
  pie: 'pie food dessert pastry filling sweet',
  chocolate_bar: 'chocolate bar food snack dessert sweet candy',
  candy: 'candy snack dessert sweet lolly',
  lollipop: 'lollipop food snack candy sweet dessert lollypop sucker',
  custard: 'custard dessert food pudding flan caramel creme sweet',
  honey_pot: 'honey pot bees sweet kitchen honeypot',
  baby_bottle: 'baby bottle food container milk drink feeding',
  milk_glass: 'milk glass of beverage drink cow',
  coffee: 'coffee hot beverage caffeine latte espresso mug cafe chocolate drink steaming tea',
  teapot: 'teapot drink hot kettle pot tea',
  tea: 'tea teacup without handle drink bowl breakfast green british beverage cup matcha',
  sake: 'sake wine drink drunk beverage japanese alcohol booze bar bottle cup rice',
  champagne: 'champagne bottle with popping cork drink wine celebration bar bubbly party sparkling',
  wine_glass: 'wine glass drink beverage drunk alcohol booze bar red',
  cocktail: 'cocktail glass drink drunk alcohol beverage booze mojito bar martini',
  tropical_drink: 'tropical drink beverage cocktail summer beach alcohol booze mojito bar fruit punch tiki vacation',
  beer: 'beer mug relax beverage drink drunk party pub summer alcohol booze bar stein',
  beers: 'beers clinking beer mugs relax beverage drink drunk party pub summer alcohol booze bar cheers clink drinks mug',
  clinking_glasses: 'clinking glasses beverage drink party alcohol celebrate cheers wine champagne toast celebration clink glass',
  tumbler_glass: 'tumbler glass drink beverage drunk alcohol liquor booze bourbon scotch whisky shot rum whiskey',
  cup_with_straw: 'cup with straw drink soda go juice malt milkshake pop smoothie soft tableware water',
  bubble_tea: 'bubble tea taiwan boba milk straw momi pearl tapioca',
  beverage_box: 'beverage box drink juice straw sweet',
  mate: 'mate drink tea beverage bombilla chimarr o cimarr n mat yerba',
  ice_cube: 'ice cube water cold iceberg',
  chopsticks: 'chopsticks food hashi jeotgarak kuaizi',
  plate_with_cutlery: 'plate with cutlery fork and knife food eat meal lunch dinner restaurant cooking dining tableware',
  fork_and_knife: 'fork and knife cutlery kitchen cooking silverware tableware',
  spoon: 'spoon cutlery kitchen tableware',
  hocho: 'hocho kitchen knife blade cutlery weapon butchers chop cooking cut tool',
  amphora: 'amphora vase jar aquarius cooking drink jug tool zodiac',
  beans: 'beans food kidney legume',
  pouring_liquid: 'pouring liquid cup water drink empty glass spill',
  jar: 'jar container sauce condiment empty store',
  ginger_root: 'ginger root spice yellow cooking gingerbread',
  pea_pod: 'pea pod cozy green',
  lime: 'lime fruit acidic citric',
  brown_mushroom: 'brown mushroom toadstool fungus',
  jack_o_lantern: 'jack o lantern halloween light pumpkin creepy fall activity celebration entertainment gourd',
  christmas_tree: 'christmas tree festival vacation december xmas celebration activity entertainment',
  fireworks: 'fireworks photo festival carnival congratulations activity celebration entertainment explosion',
  sparkler: 'sparkler stars night shine activity celebration entertainment firework fireworks hanabi senko sparkle',
  firecracker: 'firecracker dynamite boom explode explosion explosive fireworks',
  sparkles: 'sparkles stars shine shiny cool awesome good magic entertainment glitter sparkle star',
  balloon: 'balloon party celebration birthday circus activity entertainment red',
  tada: 'tada party popper congratulations birthday magic circus celebration activity entertainment hat hooray',
  confetti_ball: 'confetti ball festival party birthday circus activity celebration entertainment',
  tanabata_tree: 'tanabata tree plant nature branch summer bamboo wish star festival tanzaku activity banner celebration entertainment japanese',
  bamboo: 'bamboo pine decoration japanese plant nature vegetable panda new years activity celebration kadomatsu year',
  dolls: 'dolls japanese toy kimono activity celebration doll entertainment festival hinamatsuri imperial',
  flags: 'flags carp streamer fish japanese koinobori banner activity celebration entertainment flag socks wind',
  wind_chime: 'wind chime nature ding spring bell activity celebration entertainment furin jellyfish',
  rice_scene: 'rice scene moon viewing ceremony photo japan asia tsukimi activity autumn celebration dumplings entertainment festival grass harvest mid',
  red_envelope: 'red envelope gift ang good h ngb o lai luck money packet pao see',
  ribbon: 'ribbon decoration pink girl bowtie bow celebration',
  gift: 'gift wrapped present birthday christmas xmas box celebration entertainment',
  reminder_ribbon: 'reminder ribbon sports cause support awareness celebration',
  tickets: 'tickets admission sports concert entrance entertainment ticket',
  ticket: 'ticket event concert pass activity admission entertainment stub tour world',
  medal_military: 'medal military award winning army celebration decoration medallion',
  trophy: 'trophy win award contest place ftw ceremony championship prize winner winners',
  medal_sports: 'medal sports award winning gold winner',
  '1st_place_medal': '1st place medal award winning first gold',
  '2nd_place_medal': '2nd place medal award second silver',
  '3rd_place_medal': '3rd place medal award third bronze',
  soccer: 'soccer ball sports football',
  baseball: 'baseball sports balls ball softball',
  softball: 'softball sports balls ball game glove sport underarm',
  basketball: 'basketball sports balls nba ball hoop orange',
  volleyball: 'volleyball sports balls ball game',
  football: 'football american sports balls nfl ball gridiron superbowl',
  rugby_football: 'rugby football sports team ball league union',
  tennis: 'tennis sports balls green ball racket racquet',
  flying_disc: 'flying disc sports frisbee ultimate game golf sport',
  bowling: 'bowling sports fun play ball game pin pins skittles ten',
  cricket_game: 'cricket game sports ball bat field',
  field_hockey: 'field hockey sports ball game stick',
  ice_hockey: 'ice hockey sports game puck stick',
  lacrosse: 'lacrosse sports ball stick game goal sport',
  ping_pong: 'ping pong sports pingpong ball bat game paddle table tennis',
  badminton: 'badminton sports birdie game racquet shuttlecock',
  boxing_glove: 'boxing glove sports fighting',
  martial_arts_uniform: 'martial arts uniform judo karate taekwondo',
  goal_net: 'goal net sports catch',
  golf: 'golf flag in hole sports business summer',
  ice_skate: 'ice skate sports skating',
  fishing_pole_and_fish: 'fishing pole and fish food hobby summer entertainment rod',
  diving_mask: 'diving mask sport ocean scuba snorkeling',
  running_shirt_with_sash: 'running shirt with sash play pageant athletics marathon singlet',
  ski: 'ski skis sports winter cold snow boot skiing',
  sled: 'sled sleigh luge toboggan sledge',
  curling_stone: 'curling stone sports game rock',
  dart: 'dart bullseye direct hit game play bar target activity archery bull darts entertainment eye',
  yo_yo: 'yo toy fluctuate yoyo',
  kite: 'kite wind fly soar toy',
  '8ball': '8ball pool 8 ball hobby game luck magic billiard billiards cue eight snooker',
  crystal_ball: 'crystal ball disco party magic circus fortune teller clairvoyant fairy fantasy psychic purple tale tool',
  magic_wand: 'magic wand supernature power witch wizard',
  nazar_amulet: 'nazar amulet bead charm boncu u evil eye talisman',
  video_game: 'video game play console ps4 controller entertainment gamepad playstation u wii xbox',
  joystick: 'joystick game play entertainment video',
  slot_machine: 'slot machine bet gamble vegas fruit luck casino activity gambling game poker',
  game_die: 'game die dice random tabletop play luck entertainment gambling',
  jigsaw: 'jigsaw puzzle piece interlocking clue',
  teddy_bear: 'teddy bear plush stuffed plaything toy',
  pinata: 'pinata pi ata mexico candy celebration party',
  nesting_dolls: 'nesting dolls matryoshka toy doll russia russian',
  spades: 'spades spade suit poker cards suits magic black card game',
  hearts: 'hearts heart suit poker cards magic suits black card game',
  diamonds: 'diamonds diamond suit poker cards magic suits black card game',
  clubs: 'clubs club suit poker cards magic suits black card game',
  chess_pawn: 'chess pawn expendable black dupe game piece',
  black_joker: 'black joker poker cards game play magic card entertainment playing wildcard',
  mahjong: 'mahjong red dragon game play chinese kanji tile',
  flower_playing_cards: 'flower playing cards game sunset red activity card deck entertainment hanafuda hwatu japanese of',
  performing_arts: 'performing arts acting theater drama activity art comedy entertainment greek logo mask masks theatre tragedy',
  framed_picture: 'framed picture photography art frame museum painting',
  art: 'art artist palette design paint draw colors activity entertainment museum painting improve',
  thread: 'thread needle sewing spool string crafts',
  sewing_needle: 'sewing needle stitches embroidery sutures tailoring',
  yarn: 'yarn ball crochet knit crafts',
  knot: 'knot rope scout tangled tie twine twist',
  mirror_ball: 'mirror ball disco dance party glitter',
  earth_africa: 'earth africa globe showing europe world international planet',
  earth_americas: 'earth americas globe showing world usa international planet',
  earth_asia: 'earth asia globe showing australia world east international planet',
  globe_with_meridians: 'globe with meridians earth international world internet interweb i18n global web wide www internationalization localization',
  world_map: 'world map location direction travel',
  japan: 'japan map of nation country japanese asia silhouette',
  compass: 'compass magnetic navigation orienteering',
  mountain_snow: 'mountain snow capped photo nature environment winter cold',
  mountain: 'mountain photo nature environment',
  volcano: 'volcano photo nature disaster eruption mountain weather',
  mount_fuji: 'mount fuji photo mountain nature japanese capped san snow',
  camping: 'camping photo outdoors tent campsite',
  beach_umbrella: 'beach umbrella with weather summer sunny sand mojito',
  desert: 'desert photo warm saharah',
  desert_island: 'desert island photo tropical mojito',
  national_park: 'national park photo environment nature',
  stadium: 'stadium photo place sports concert venue grandstand sport',
  classical_building: 'classical building art culture history',
  building_construction: 'building construction wip working progress crane architectural',
  bricks: 'bricks brick clay construction mortar wall infrastructure',
  rock: 'rock stone boulder construction heavy solid',
  wood: 'wood nature timber trunk construction log lumber',
  hut: 'hut house structure roundhouse yurt',
  houses: 'houses buildings photo building group house',
  derelict_house: 'derelict house abandon evict broken building abandoned haunted old',
  house: 'house building home',
  house_with_garden: 'house with garden home plant nature building tree',
  office: 'office building bureau work city high rise',
  post_office: 'post office japanese building envelope communication japan mark postal',
  european_post_office: 'european post office building email',
  hospital: 'hospital building health surgery doctor cross emergency medical medicine red room',
  bank: 'bank building money sales cash business enterprise bakkureru bk branch',
  hotel: 'hotel building accomodation checkin accommodation h',
  love_hotel: 'love hotel like affection dating building heart hospital',
  convenience_store: 'convenience store building shopping groceries corner e eleven hour kwik mart shop',
  school: 'school building student education learn teach clock elementary high middle tower',
  department_store: 'department store building shopping mall center shops',
  factory: 'factory building industry pollution smoke industrial smog',
  japanese_castle: 'japanese castle photo building fortress',
  european_castle: 'european castle building royalty history turrets',
  wedding: 'wedding love like affection couple marriage bride groom activity chapel church heart romance',
  tokyo_tower: 'tokyo tower photo japanese eiffel red',
  statue_of_liberty: 'statue of liberty american newyork new york',
  church: 'church building religion christ christian cross',
  mosque: 'mosque islam worship minaret domed muslim religion roof',
  hindu_temple: 'hindu temple religion',
  synagogue: 'synagogue judaism worship temple jewish jew religion synagog',
  shinto_shrine: 'shinto shrine temple japan kyoto kami michi no religion',
  kaaba: 'kaaba mecca mosque islam muslim religion',
  fountain: 'fountain photo summer water fresh feature park',
  tent: 'tent photo camping outdoors',
  foggy: 'foggy photo mountain bridge city fog karl under weather',
  night_with_stars: 'night with stars evening city downtown star starry weather',
  cityscape: 'cityscape photo night life urban building city skyline',
  sunrise_over_mountains: 'sunrise over mountains view vacation photo morning mountain sun weather',
  sunrise: 'sunrise morning view vacation photo sun sunset weather',
  city_sunset: 'city sunset cityscape at dusk photo evening sky buildings building landscape orange sun weather',
  city_sunrise: 'city sunrise sunset photo good morning dawn building buildings dusk over sun weather',
  bridge_at_night: 'bridge at night photo sanfrancisco gate golden weather',
  hotsprings: 'hotsprings hot springs bath warm relax onsen steam steaming',
  carousel_horse: 'carousel horse photo carnival activity entertainment fairground go merry round',
  ferris_wheel: 'ferris wheel photo carnival londoneye activity amusement big entertainment fairground observation park',
  roller_coaster: 'roller coaster carnival playground photo fun activity amusement entertainment park rollercoaster theme',
  barber: 'barber pole hair salon style s haircut hairdresser shop stripes',
  circus_tent: 'circus tent festival carnival party activity big entertainment top',
  steam_locomotive: 'steam locomotive transportation vehicle train engine railway',
  railway_car: 'railway car transportation vehicle carriage electric railcar railroad train tram trolleybus wagon',
  bullettrain_side: 'bullettrain side high speed train transportation vehicle railway shinkansen',
  bullettrain_front: 'bullettrain front bullet train transportation vehicle speed fast public travel high nose railway shinkansen',
  train2: 'train2 train transportation vehicle diesel electric passenger railway regular',
  metro: 'metro transportation blue square mrt underground tube subway train vehicle',
  light_rail: 'light rail transportation vehicle railway',
  station: 'station transportation vehicle public platform railway train',
  tram: 'tram transportation vehicle trolleybus',
  monorail: 'monorail transportation vehicle',
  mountain_railway: 'mountain railway transportation vehicle car funicular train',
  train: 'train tram car transportation vehicle carriage public travel trolleybus',
  bus: 'bus car vehicle transportation school',
  oncoming_bus: 'oncoming bus vehicle transportation front',
  trolleybus: 'trolleybus bart transportation vehicle bus electric tram trolley',
  minibus: 'minibus vehicle car transportation bus minivan mover people',
  ambulance: 'ambulance health 911 hospital vehicle',
  fire_engine: 'fire engine transportation cars vehicle department truck',
  police_car: 'police car vehicle cars transportation law legal enforcement cop patrol side',
  oncoming_police_car: 'oncoming police car vehicle law legal enforcement 911 front of cop',
  taxi: 'taxi uber vehicle cars transportation new side taxicab york',
  oncoming_taxi: 'oncoming taxi vehicle cars uber front taxicab',
  car: 'car automobile red transportation vehicle side',
  oncoming_automobile: 'oncoming automobile car vehicle transportation front',
  blue_car: 'blue car sport utility vehicle transportation campervan motorhome recreational rv',
  pickup_truck: 'pickup truck car transportation vehicle',
  truck: 'truck delivery cars transportation vehicle resources',
  articulated_lorry: 'articulated lorry vehicle cars transportation express green semi truck',
  tractor: 'tractor vehicle car farming agriculture farm',
  racing_car: 'racing car sports race fast formula f1 one',
  motorcycle: 'motorcycle race sports fast motorbike racing',
  motor_scooter: 'motor scooter vehicle vespa sasha bike cycle',
  manual_wheelchair: 'manual wheelchair accessibility',
  motorized_wheelchair: 'motorized wheelchair accessibility',
  auto_rickshaw: 'auto rickshaw move transportation tuk',
  bike: 'bike bicycle sports exercise hipster push vehicle',
  kick_scooter: 'kick scooter vehicle razor',
  skateboard: 'skateboard board skate',
  roller_skate: 'roller skate footwear sports derby inline',
  busstop: 'busstop bus stop transportation wait',
  motorway: 'motorway road cupertino interstate highway',
  railway_track: 'railway track train transportation',
  oil_drum: 'oil drum barrell',
  fuelpump: 'fuelpump fuel pump gas station petroleum diesel petrol',
  rotating_light: 'rotating light police car ambulance 911 emergency alert error pinged law legal beacon cars s flashing revolving siren vehicle warning',
  traffic_light: 'traffic light horizontal transportation signal',
  vertical_traffic_light: 'vertical traffic light transportation driving semaphore signal',
  stop_sign: 'stop sign octagonal',
  construction: 'construction wip progress caution warning barrier black roadwork sign striped yellow work in',
  anchor: 'anchor ship ferry sea boat admiralty fisherman pattern tool',
  boat: 'boat sailboat ship summer transportation water sailing dinghy resort sea vehicle yacht',
  canoe: 'canoe boat paddle water ship',
  speedboat: 'speedboat ship transportation vehicle summer boat motorboat powerboat',
  passenger_ship: 'passenger ship yacht cruise ferry vehicle',
  ferry: 'ferry boat ship yacht passenger',
  motor_boat: 'motor boat ship motorboat vehicle',
  ship: 'ship transportation titanic deploy boat cruise passenger vehicle',
  airplane: 'airplane vehicle transportation flight fly aeroplane plane',
  small_airplane: 'small airplane flight transportation fly vehicle aeroplane plane',
  flight_departure: 'flight departure airplane airport landing aeroplane departures off plane taking vehicle',
  flight_arrival: 'flight arrival airplane airport boarding aeroplane arrivals arriving landing plane vehicle',
  parachute: 'parachute fly glide hang parasail skydive',
  seat: 'seat sit airplane transport bus flight fly aeroplane chair train',
  helicopter: 'helicopter transportation vehicle fly',
  suspension_railway: 'suspension railway vehicle transportation',
  mountain_cableway: 'mountain cableway transportation vehicle ski cable gondola',
  aerial_tramway: 'aerial tramway transportation vehicle ski cable car gondola ropeway',
  artificial_satellite: 'artificial satellite communication gps orbit spaceflight nasa iss space vehicle',
  rocket: 'rocket launch ship staffmode nasa outer space fly shuttle vehicle deploy',
  flying_saucer: 'flying saucer transportation vehicle ufo alien extraterrestrial fantasy space',
  bellhop_bell: 'bellhop bell service hotel',
  luggage: 'luggage packing travel suitcase',
  hourglass: 'hourglass done time clock oldschool limit exam quiz test sand timer',
  hourglass_flowing_sand: 'hourglass flowing sand not done oldschool time countdown timer',
  watch: 'watch time accessories apple clock timepiece wrist wristwatch',
  alarm_clock: 'alarm clock time wake morning',
  stopwatch: 'stopwatch time deadline clock',
  timer_clock: 'timer clock alarm',
  mantelpiece_clock: 'mantelpiece clock time',
  clock12: 'clock12 twelve o clock 12 00 0000 1200 time noon midnight midday late early schedule face oclock',
  clock1230: 'clock1230 twelve thirty 00 30 0030 12 1230 time late early schedule clock face',
  clock1: 'clock1 one o clock 1 00 100 13 1300 time late early schedule face oclock',
  clock130: 'clock130 one thirty 1 30 130 13 1330 time late early schedule clock face',
  clock2: 'clock2 two o clock 2 00 200 14 1400 time late early schedule face oclock',
  clock230: 'clock230 two thirty 2 30 230 14 1430 time late early schedule clock face',
  clock3: 'clock3 three o clock 3 00 300 15 1500 time late early schedule face oclock',
  clock330: 'clock330 three thirty 3 30 330 15 1530 time late early schedule clock face',
  clock4: 'clock4 four o clock 4 00 400 16 1600 time late early schedule face oclock',
  clock430: 'clock430 four thirty 4 30 430 16 1630 time late early schedule clock face',
  clock5: 'clock5 five o clock 5 00 500 17 1700 time late early schedule face oclock',
  clock530: 'clock530 five thirty 5 30 530 17 1730 time late early schedule clock face',
  clock6: 'clock6 six o clock 6 00 600 18 1800 time late early schedule dawn dusk face oclock',
  clock630: 'clock630 six thirty 6 30 630 18 1830 time late early schedule clock face',
  clock7: 'clock7 seven o clock 7 00 700 19 1900 time late early schedule face oclock',
  clock730: 'clock730 seven thirty 7 30 730 19 1930 time late early schedule clock face',
  clock8: 'clock8 eight o clock 8 00 800 20 2000 time late early schedule face oclock',
  clock830: 'clock830 eight thirty 8 30 830 20 2030 time late early schedule clock face',
  clock9: 'clock9 nine o clock 9 00 900 21 2100 time late early schedule face oclock',
  clock930: 'clock930 nine thirty 9 30 930 21 2130 time late early schedule clock face',
  clock10: 'clock10 ten o clock 10 00 1000 22 2200 time late early schedule face oclock',
  clock1030: 'clock1030 ten thirty 10 30 1030 22 2230 time late early schedule clock face',
  clock11: 'clock11 eleven o clock 11 00 1100 23 2300 time late early schedule face oclock',
  clock1130: 'clock1130 eleven thirty 11 30 1130 23 2330 time late early schedule clock face',
  new_moon: 'new moon nature twilight planet space night evening sleep dark eclipse shadow solar symbol weather',
  waxing_crescent_moon: 'waxing crescent moon nature twilight planet space night evening sleep symbol weather',
  first_quarter_moon: 'first quarter moon nature twilight planet space night evening sleep symbol weather',
  moon: 'moon waxing gibbous nature night sky gray twilight planet space evening sleep symbol weather',
  full_moon: 'full moon nature yellow twilight planet space night evening sleep symbol weather',
  waning_gibbous_moon: 'waning gibbous moon nature twilight planet space night evening sleep waxing symbol weather',
  last_quarter_moon: 'last quarter moon nature twilight planet space night evening sleep symbol weather',
  waning_crescent_moon: 'waning crescent moon nature twilight planet space night evening sleep symbol weather',
  crescent_moon: 'crescent moon night sleep sky evening magic space weather',
  new_moon_with_face: 'new moon with face nature twilight planet space night evening sleep creepy dark molester weather',
  first_quarter_moon_with_face: 'first quarter moon with face nature twilight planet space night evening sleep weather',
  last_quarter_moon_with_face: 'last quarter moon with face nature twilight planet space night evening sleep weather',
  thermometer: 'thermometer weather temperature hot cold',
  sunny: 'sunny sun weather nature brightness summer beach spring black bright rays space sunshine',
  full_moon_with_face: 'full moon with face nature twilight planet space night evening sleep bright moonface smiley smiling weather',
  sun_with_face: 'sun with face nature morning sky bright smiley smiling space summer sunface weather',
  ringed_planet: 'ringed planet outerspace planets saturn saturnine space',
  star: 'star night yellow gold medium white',
  star2: 'star2 glowing star night sparkle awesome good magic glittery glow shining',
  stars: 'stars shooting star night photo activity falling meteoroid space upon when wish you',
  milky_way: 'milky way photo space stars galaxy night sky universe weather',
  cloud: 'cloud weather sky cloudy overcast',
  partly_sunny: 'partly sunny sun behind cloud weather nature cloudy morning fall spring',
  cloud_with_lightning_and_rain: 'cloud with lightning and rain weather thunder',
  sun_behind_small_cloud: 'sun behind small cloud weather white',
  sun_behind_large_cloud: 'sun behind large cloud weather white',
  sun_behind_rain_cloud: 'sun behind rain cloud weather white',
  cloud_with_rain: 'cloud with rain weather',
  cloud_with_snow: 'cloud with snow weather cold',
  cloud_with_lightning: 'cloud with lightning weather thunder',
  tornado: 'tornado weather cyclone twister cloud whirlwind',
  fog: 'fog weather cloud',
  wind_face: 'wind face gust air blow blowing cloud mother nature weather',
  cyclone: 'cyclone weather swirl blue cloud vortex spiral whirlpool spin tornado hurricane typhoon dizzy twister',
  rainbow: 'rainbow nature happy unicorn face photo sky spring gay lgbt pride primary rain weather',
  closed_umbrella: 'closed umbrella weather rain drizzle clothing collapsed pink',
  open_umbrella: 'open umbrella weather spring clothing rain',
  umbrella: 'umbrella with rain drops rainy weather spring clothing drop raining',
  parasol_on_ground: 'parasol on ground umbrella weather summer beach rain sun',
  zap: 'zap high voltage thunder weather lightning bolt fast danger electric electricity sign thunderbolt speed',
  snowflake: 'snowflake winter season cold weather christmas xmas snow snowing',
  snowman_with_snow: 'snowman with snow winter season cold weather christmas xmas frozen snowflakes snowing',
  snowman: 'snowman without snow winter season cold weather christmas xmas frozen frosty olaf',
  comet: 'comet space',
  fire: 'fire hot cook flame burn lit snapstreak tool remove',
  droplet: 'droplet water drip faucet spring cold comic drop sweat weather',
  ocean: 'ocean water wave sea nature tsunami disaster beach waves weather',
  playground_slide: 'playground slide fun park amusement play',
  wheel: 'wheel car transport circle tire turn',
  ring_buoy: 'ring buoy life saver preserver float rescue safety',
  eyeglasses: 'eyeglasses glasses fashion accessories eyesight nerdy dork geek clothing eye eyewear',
  dark_sunglasses: 'dark sunglasses face cool accessories eye eyewear glasses',
  goggles: 'goggles eyes protection safety clothing eye swimming welding',
  lab_coat: 'lab coat doctor experiment scientist chemist clothing',
  safety_vest: 'safety vest protection emergency',
  necktie: 'necktie shirt suitup formal fashion cloth business clothing tie',
  shirt: 'shirt t fashion cloth casual tee clothing polo tshirt',
  jeans: 'jeans fashion shopping clothing denim pants trousers',
  scarf: 'scarf neck winter clothes clothing',
  gloves: 'gloves hands winter clothes clothing hand',
  coat: 'coat jacket clothing',
  socks: 'socks stockings clothes clothing pair stocking',
  dress: 'dress clothes fashion shopping clothing gown skirt',
  kimono: 'kimono dress fashion women female japanese clothing dressing gown',
  sari: 'sari dress clothing saree shari',
  one_piece_swimsuit: 'one piece swimsuit fashion bathing clothing suit swim',
  swim_brief: 'swim brief briefs clothing bathing suit swimsuit underwear',
  shorts: 'shorts clothing bathing pants suit swim swimsuit underwear',
  bikini: 'bikini swimming female woman girl fashion beach summer bathers clothing swim swimsuit',
  womans_clothes: 'womans clothes woman s fashion shopping bags female blouse clothing pink shirt',
  purse: 'purse fashion accessories money sales shopping clothing coin wallet',
  handbag: 'handbag fashion accessory accessories shopping bag clothing purse women s',
  pouch: 'pouch clutch bag accessories shopping clothing small',
  shopping: 'shopping bags mall buy purchase bag hotel',
  school_satchel: 'school satchel backpack student education bag activity rucksack',
  thong_sandal: 'thong sandal footwear summer beach flip flops jandals sandals thongs z ri',
  mans_shoe: 'mans shoe man s fashion male brown clothing dress',
  athletic_shoe: 'athletic shoe running shoes sports sneakers clothing runner sneaker sport tennis trainer',
  hiking_boot: 'hiking boot backpacking camping clothing',
  flat_shoe: 'flat shoe ballet slip on slipper clothing woman s',
  high_heel: 'high heel heeled shoe fashion shoes female pumps stiletto clothing heels woman',
  sandal: 'sandal woman s shoes fashion flip flops clothing heeled sandals shoe womans',
  ballet_shoes: 'ballet shoes dance clothing pointe shoe',
  boot: 'boot woman s shoes fashion boots clothing cowgirl heeled high knee shoe womans',
  crown: 'crown king kod leader royalty lord clothing queen royal',
  womans_hat: 'womans hat woman s fashion accessories female lady spring bow clothing ladies',
  tophat: 'tophat top hat magic gentleman classy circus activity clothing entertainment formal groom wear',
  mortar_board: 'mortar board graduation cap school college degree university hat legal learn education academic activity celebration clothing graduate square',
  billed_cap: 'billed cap baseball clothing hat',
  military_helmet: 'military helmet army protection soldier warrior',
  rescue_worker_helmet: 'rescue worker helmet s construction build aid cross face hat white',
  prayer_beads: 'prayer beads dhikr religious clothing necklace religion rosary',
  lipstick: 'lipstick female girl fashion woman cosmetics gloss lip makeup style',
  ring: 'ring wedding propose marriage valentines diamond fashion jewelry gem engagement engaged romance',
  gem: 'gem stone blue ruby diamond jewelry gemstone jewel romance',
  mute: 'mute muted speaker sound volume silence quiet cancellation off silent stroke',
  speaker: 'speaker low volume sound silence broadcast soft',
  sound: 'sound speaker medium volume broadcast low one reduce wave',
  loud_sound: 'loud sound speaker high volume noise noisy broadcast entertainment increase three waves',
  loudspeaker: 'loudspeaker volume sound address announcement bullhorn communication loud megaphone pa public system',
  mega: 'mega megaphone sound speaker volume bullhorn cheering communication',
  postal_horn: 'postal horn instrument music bugle communication entertainment french post',
  bell: 'bell sound notification christmas xmas chime liberty ringer wedding',
  no_bell: 'no bell with slash sound volume mute quiet silent cancellation disabled forbidden muted not notifications off prohibited ringer stroke',
  musical_score: 'musical score treble clef compose activity entertainment music sheet',
  musical_note: 'musical note score tone sound activity beamed eighth entertainment music notes pair quavers',
  notes: 'notes musical music score activity entertainment multiple note singing',
  studio_microphone: 'studio microphone sing recording artist talkshow mic music podcast',
  level_slider: 'level slider scale music',
  control_knobs: 'control knobs dial music',
  microphone: 'microphone sound music pa sing talkshow activity entertainment karaoke mic singing',
  headphones: 'headphones headphone music score gadgets activity earbud earphone earphones entertainment ipod',
  radio: 'radio communication music podcast program digital entertainment video wireless',
  saxophone: 'saxophone music instrument jazz blues activity entertainment sax',
  accordion: 'accordion music accordian box concertina squeeze',
  guitar: 'guitar music instrument acoustic activity bass electric entertainment rock',
  musical_keyboard: 'musical keyboard piano instrument compose activity entertainment music',
  trumpet: 'trumpet music brass activity entertainment horn instrument jazz',
  violin: 'violin music instrument orchestra symphony activity entertainment quartet smallest string world s',
  banjo: 'banjo music instructment activity entertainment instrument stringed',
  drum: 'drum music instrument drumsticks snare',
  long_drum: 'long drum music beat conga djembe rhythm',
  iphone: 'iphone mobile phone technology apple gadgets dial cell communication smartphone telephone responsive design',
  calling: 'calling mobile phone with arrow iphone incoming call cell communication left pointing receive rightwards telephone',
  phone: 'phone telephone technology communication dial black rotary',
  telephone_receiver: 'telephone receiver technology communication dial call handset phone',
  pager: 'pager bbcall oldschool 90s beeper bleeper communication',
  fax: 'fax machine communication technology facsimile',
  battery: 'battery power energy sustain aa phone',
  electric_plug: 'electric plug charger power ac adaptor cable electricity',
  computer: 'computer laptop technology screen display monitor desktop notebook pc personal',
  desktop_computer: 'desktop computer technology computing screen imac',
  printer: 'printer paper ink computer',
  keyboard: 'keyboard technology computer type input text',
  computer_mouse: 'computer mouse click button three',
  trackball: 'trackball technology trackpad computer',
  minidisc: 'minidisc computer disk technology record data 90s entertainment minidisk optical',
  floppy_disk: 'floppy disk oldschool technology save 90s 80s computer',
  cd: 'cd optical disk technology dvd disc 90s compact computer rom',
  dvd: 'dvd cd disk disc computer entertainment optical rom video',
  abacus: 'abacus calculation count counting frame math',
  movie_camera: 'movie camera film record activity cinema entertainment hollywood video',
  film_strip: 'film strip frames movie cinema entertainment',
  film_projector: 'film projector video tape record movie cinema entertainment',
  clapper: 'clapper board movie film record activity clapboard director entertainment slate',
  tv: 'tv television technology program oldschool show entertainment video',
  camera: 'camera gadgets photography digital entertainment photo video',
  camera_flash: 'camera flash with photography gadgets photo video snapshots',
  video_camera: 'video camera film record camcorder entertainment',
  vhs: 'vhs videocassette record video oldschool 90s 80s entertainment tape vcr',
  mag: 'mag magnifying glass tilted left search zoom find detective icon magnifier pointing tool',
  mag_right: 'mag right magnifying glass tilted search zoom find detective icon magnifier pointing tool seo',
  candle: 'candle fire wax light',
  bulb: 'bulb light electricity idea comic electric',
  flashlight: 'flashlight dark camping sight night electric light tool torch',
  izakaya_lantern: 'izakaya lantern red paper light halloween spooky asian bar japanese',
  diya_lamp: 'diya lamp lighting oil',
  notebook_with_decorative_cover: 'notebook with decorative cover classroom notes record paper study book decorated',
  closed_book: 'closed book read library knowledge textbook learn red',
  book: 'book open read library knowledge literature learn study novel',
  green_book: 'green book read library knowledge study textbook',
  blue_book: 'blue book read library knowledge learn study textbook',
  orange_book: 'orange book read library knowledge textbook study',
  books: 'books literature library study book pile stack',
  notebook: 'notebook stationery record notes paper study black book composition white',
  ledger: 'ledger notes paper binder book bound notebook spiral yellow',
  page_with_curl: 'page with curl documents office paper curled curly document license',
  scroll: 'scroll documents ancient history paper degree document parchment',
  page_facing_up: 'page facing up documents office paper information document printed',
  newspaper: 'newspaper press headline communication news paper',
  newspaper_roll: 'newspaper roll rolled up press headline delivery news paper',
  bookmark_tabs: 'bookmark tabs favorite save order tidy mark marker',
  bookmark: 'bookmark favorite label save mark price tag',
  label: 'label sale tag',
  moneybag: 'moneybag money bag dollar payment coins sale cream moneybags rich',
  coin: 'coin money currency gold metal silver treasure',
  yen: 'yen banknote money sales japanese dollar currency bank banknotes bill note sign',
  dollar: 'dollar banknote money sales bill currency american bank banknotes note sign',
  euro: 'euro banknote money sales dollar currency bank banknotes bill note sign',
  pound: 'pound banknote british sterling money sales bills uk england currency bank banknotes bill note quid sign twenty',
  money_with_wings: 'money with wings dollar bills payment sale bank banknote bill fly flying losing note',
  credit_card: 'credit card money sales dollar bill payment shopping amex bank club diners mastercard subscription visa',
  receipt: 'receipt accounting expenses bookkeeping evidence proof',
  chart: 'chart increasing with yen green square graph presentation stats bank currency exchange growth market money rate rise sign trend upward upwards',
  envelope: 'envelope letter postal inbox communication email',
  'e-mail': 'e mail communication inbox email letter symbol',
  incoming_envelope: 'incoming envelope email inbox communication fast letter lines mail receive',
  envelope_with_arrow: 'envelope with arrow email communication above down downwards insert letter mail outgoing sent',
  outbox_tray: 'outbox tray inbox email box communication letter mail sent',
  inbox_tray: 'inbox tray email documents box communication letter mail receive',
  package: 'package mail gift cardboard box moving communication parcel shipping container',
  mailbox: 'mailbox closed with raised flag email inbox communication mail postbox',
  mailbox_closed: 'mailbox closed with lowered flag email communication inbox mail postbox',
  mailbox_with_mail: 'mailbox with mail open raised flag email inbox communication postbox',
  mailbox_with_no_mail: 'mailbox with no mail open lowered flag email inbox communication postbox',
  postbox: 'postbox email letter envelope communication mail mailbox',
  ballot_box: 'ballot box with election vote voting',
  pencil2: 'pencil2 pencil stationery write paper writing school study lead typos',
  black_nib: 'black nib pen stationery writing write fountain',
  fountain_pen: 'fountain pen stationery writing write communication left lower',
  pen: 'pen stationery writing write ballpoint communication left lower',
  paintbrush: 'paintbrush drawing creativity art brush communication left lower painting',
  crayon: 'crayon drawing creativity communication left lower',
  memo: 'memo write documents stationery pencil paper writing legal exam quiz test study compose communication document memorandum note documentation',
  briefcase: 'briefcase business documents work law legal job career suitcase',
  file_folder: 'file folder documents business office closed directory manilla',
  open_file_folder: 'open file folder documents load',
  card_index_dividers: 'card index dividers organizing business stationery',
  date: 'date calendar schedule day emoji july world',
  calendar: 'calendar tear off schedule date planning day desk',
  spiral_notepad: 'spiral notepad memo stationery note pad',
  spiral_calendar: 'spiral calendar date schedule planning pad',
  card_index: 'card index business stationery rolodex system',
  chart_with_upwards_trend: 'chart with upwards trend increasing graph presentation stats recovery business economics money sales good success growth metrics pointing positive up upward analytics',
  chart_with_downwards_trend: 'chart with downwards trend decreasing graph presentation stats recession business economics money sales bad failure down pointing metrics negative',
  bar_chart: 'bar chart graph presentation stats metrics',
  clipboard: 'clipboard stationery documents',
  pushpin: 'pushpin stationery mark here location pin tack thumb',
  round_pushpin: 'round pushpin stationery location map here dropped pin red',
  paperclip: 'paperclip documents stationery clippy',
  paperclips: 'paperclips linked documents stationery communication link paperclip',
  straight_ruler: 'straight ruler stationery calculate length math school drawing architect sketch edge',
  triangular_ruler: 'triangular ruler stationery math architect sketch set triangle',
  scissors: 'scissors stationery cut black cutting tool',
  card_file_box: 'card file box business stationery database',
  file_cabinet: 'file cabinet filing organizing',
  wastebasket: 'wastebasket bin trash rubbish garbage toss basket can litter wastepaper',
  lock: 'lock locked security password padlock closed private privacy',
  unlock: 'unlock unlocked privacy security lock open padlock',
  lock_with_ink_pen: 'lock with ink pen locked security secret fountain nib privacy',
  closed_lock_with_key: 'closed lock with key locked security privacy secure secret',
  key: 'key lock door password gold',
  old_key: 'old key lock door password clue',
  hammer: 'hammer tools build create claw handyman tool',
  axe: 'axe tool chop cut hatchet split wood',
  pick: 'pick tools dig mining pickaxe tool',
  hammer_and_pick: 'hammer and pick tools build create tool',
  hammer_and_wrench: 'hammer and wrench tools build create spanner tool',
  dagger: 'dagger weapon knife',
  crossed_swords: 'crossed swords weapon',
  gun: 'gun water pistol violence weapon revolver handgun shoot squirt tool',
  boomerang: 'boomerang weapon australia rebound repercussion',
  bow_and_arrow: 'bow and arrow sports archer archery sagittarius tool zodiac',
  shield: 'shield protection security weapon',
  carpentry_saw: 'carpentry saw cut chop carpenter hand lumber tool',
  wrench: 'wrench tools diy ikea fix maintainer spanner tool',
  screwdriver: 'screwdriver tools screw tool',
  nut_and_bolt: 'nut and bolt handy tools fix screw tool',
  gear: 'gear cog cogwheel tool',
  clamp: 'clamp tool compress compression table vice winzip',
  balance_scale: 'balance scale law fairness weight justice libra scales tool zodiac',
  probing_cane: 'probing cane white accessibility blind',
  link: 'link rings url chain hyperlink linked symbol',
  chains: 'chains lock arrest chain',
  hook: 'hook tools catch crook curve ensnare fishing point selling tool',
  toolbox: 'toolbox tools diy fix maintainer mechanic chest tool',
  magnet: 'magnet attraction magnetic horseshoe',
  ladder: 'ladder tools climb rung step tool',
  alembic: 'alembic distilling science experiment chemistry tool',
  test_tube: 'test tube chemistry experiment lab science chemist',
  petri_dish: 'petri dish bacteria biology culture lab biologist',
  dna: 'dna biologist genetics life double evolution gene helix',
  microscope: 'microscope laboratory experiment zoomin science study investigate magnify tool',
  telescope: 'telescope stars space zoom science astronomy stargazing tool',
  satellite: 'satellite antenna communication future radio space dish signal',
  syringe: 'syringe health hospital drugs blood medicine needle doctor nurse shot sick tool vaccination vaccine',
  drop_of_blood: 'drop of blood period hurt harm wound bleed doctor donation injury medicine menstruation',
  pill: 'pill health medicine doctor pharmacy drug capsule drugs sick tablet',
  adhesive_bandage: 'adhesive bandage heal aid band doctor medicine plaster',
  stethoscope: 'stethoscope health doctor heart medicine healthcheck',
  door: 'door house entry exit doorway front',
  elevator: 'elevator lift accessibility hoist',
  mirror: 'mirror reflection reflector speculum',
  window: 'window scenery air frame fresh glass opening transparent view',
  bed: 'bed sleep rest bedroom hotel',
  couch_and_lamp: 'couch and lamp read chill hotel lounge settee sofa',
  chair: 'chair sit furniture seat',
  toilet: 'toilet restroom wc washroom bathroom potty loo',
  plunger: 'plunger toilet cup force plumber suction',
  shower: 'shower clean water bathroom bath head',
  bathtub: 'bathtub clean shower bathroom bath bubble',
  mouse_trap: 'mouse trap cheese bait mousetrap rodent snare',
  razor: 'razor cut sharp shave',
  lotion_bottle: 'lotion bottle moisturizer sunscreen shampoo',
  safety_pin: 'safety pin diaper punk rock',
  broom: 'broom cleaning sweeping witch brush sweep',
  basket: 'basket laundry farming picnic',
  roll_of_paper: 'roll of paper toilet towels',
  bucket: 'bucket water container cask pail vat',
  soap: 'soap bar bathing cleaning lather soapdish',
  toothbrush: 'toothbrush hygiene dental bathroom brush clean teeth',
  sponge: 'sponge absorbing cleaning porous',
  fire_extinguisher: 'fire extinguisher quench extinguish',
  shopping_cart: 'shopping cart trolley',
  smoking: 'smoking cigarette kills tobacco joint smoke activity symbol',
  coffin: 'coffin vampire dead die death rip graveyard cemetery casket funeral box remove',
  headstone: 'headstone death rip grave cemetery graveyard halloween tombstone',
  funeral_urn: 'funeral urn dead die death rip ashes vase',
  moyai: 'moyai moai rock easter island carving face human statue stone',
  placard: 'placard announcement demonstration lawn picket post protest sign',
  hamsa: 'hamsa religion protection amulet fatima hand mary miriam',
  low_battery: 'low battery drained dead electronic energy no red',
  crutch: 'crutch accessibility assist aid cane disability hurt mobility stick',
  x_ray: 'x ray skeleton medicine bones doctor medical',
  bubbles: 'bubbles soap fun carbonation sparkling burp clean underwater',
  identification_card: 'identification card document credentials id license security',
  folding_hand_fan: 'folding hand fan flamenco hot sensu',
  hair_pick: 'hair pick afro comb',
  maracas: 'maracas music instrument percussion shaker',
  flute: 'flute bamboo music instrument pied piper recorder',
  broken_chain: 'broken chain constraint break',
  1234: '1234 input numbers blue square 1 2 3 4 for numeric symbol',
  atm: 'atm sign money sales cash blue square payment bank automated machine teller',
  put_litter_in_its_place: 'put litter in its place bin sign blue square human info litterbox person symbol trash',
  potable_water: 'potable water blue square liquid restroom cleaning faucet drink drinking symbol tap thirst thirsty',
  wheelchair: 'wheelchair symbol blue square disabled accessibility access accessible bathroom',
  mens: 'mens men s room toilet restroom wc blue square gender male lavatory man symbol',
  womens: 'womens women s room purple square woman female toilet loo restroom gender lavatory symbol wc',
  restroom: 'restroom blue square toilet refresh wc gender bathroom lavatory sign',
  baby_symbol: 'baby symbol orange square child change changing nursery station',
  wc: 'wc water closet toilet restroom blue square lavatory',
  passport_control: 'passport control custom blue square border permissions authorization roles',
  customs: 'customs passport border blue square',
  baggage_claim: 'baggage claim blue square airport transport',
  left_luggage: 'left luggage blue square travel baggage bag with key locked locker suitcase',
  warning: 'warning exclamation wip alert error problem issue sign symbol',
  children_crossing: 'children crossing school warning danger sign driving yellow diamond child kids pedestrian traffic experience usability',
  no_entry: 'no entry limit security privacy bad denied stop circle forbidden not prohibited traffic',
  no_entry_sign: 'no entry sign prohibited forbid stop limit denied disallow circle backslash banned block crossed forbidden not red restricted',
  no_bicycles: 'no bicycles bikes bicycle bike cyclist prohibited circle forbidden not sign vehicle',
  no_smoking: 'no smoking cigarette blue square smell smoke forbidden not prohibited sign symbol',
  do_not_litter: 'do not litter no littering trash bin garbage circle forbidden prohibited symbol',
  'non-potable_water': 'non potable water drink faucet tap circle drinking forbidden no not prohibited symbol',
  no_pedestrians: 'no pedestrians rules crossing walking circle forbidden not pedestrian people prohibited',
  no_mobile_phones: 'no mobile phones iphone mute circle cell communication forbidden not phone prohibited smartphones telephone',
  underage: 'underage no one under eighteen 18 drink pub night minor circle age forbidden not nsfw prohibited restriction symbol',
  radioactive: 'radioactive nuclear danger international radiation sign symbol',
  biohazard: 'biohazard danger sign',
  arrow_up: 'arrow up blue square continue top direction black cardinal north pointing upwards upgrade',
  arrow_upper_right: 'arrow upper right up blue square point direction diagonal northeast east intercardinal north',
  arrow_right: 'arrow right blue square next black cardinal direction east pointing rightwards',
  arrow_lower_right: 'arrow lower right down blue square direction diagonal southeast east intercardinal south',
  arrow_down: 'arrow down blue square direction bottom black cardinal downwards pointing south downgrade',
  arrow_lower_left: 'arrow lower left down blue square direction diagonal southwest intercardinal south west',
  arrow_left: 'arrow left blue square previous back black cardinal direction leftwards pointing west',
  arrow_upper_left: 'arrow upper left up blue square point direction diagonal northwest intercardinal north west',
  arrow_up_down: 'arrow up down blue square direction way vertical arrows intercardinal northwest',
  left_right_arrow: 'left right arrow shape direction horizontal sideways arrows',
  leftwards_arrow_with_hook: 'leftwards arrow with hook right curving left back return blue square undo enter curved email reply',
  arrow_right_hook: 'arrow right hook left curving blue square return rotate direction email forward rightwards curved',
  arrow_heading_up: 'arrow heading up right curving blue square direction top pointing rightwards then upwards',
  arrow_heading_down: 'arrow heading down right curving blue square direction bottom curved downwards pointing rightwards then',
  arrows_clockwise: 'arrows clockwise vertical sync cycle round repeat arrow circle downwards open reload upwards',
  arrows_counterclockwise: 'arrows counterclockwise button blue square sync cycle anticlockwise arrow circle downwards open refresh rotate switch upwards withershins',
  back: 'back arrow words return above leftwards',
  end: 'end arrow words above leftwards',
  on: 'on arrow words above exclamation left mark right',
  soon: 'soon arrow words above rightwards',
  top: 'top arrow words blue square above up upwards',
  place_of_worship: 'place of worship religion church temple prayer building religious',
  atom_symbol: 'atom symbol science physics chemistry atheist',
  om: 'om hinduism buddhism sikhism jainism aumkara hindu omkara pranava religion symbol',
  star_of_david: 'star of david judaism jew jewish magen religion',
  wheel_of_dharma: 'wheel of dharma hinduism buddhism sikhism jainism buddhist helm religion',
  yin_yang: 'yin yang balance religion tao taoist',
  latin_cross: 'latin cross christianity christian religion',
  orthodox_cross: 'orthodox cross suppedaneum religion christian',
  star_and_crescent: 'star and crescent islam muslim religion',
  peace_symbol: 'peace symbol hippie sign',
  menorah: 'menorah hanukkah candles jewish branches candelabrum candlestick chanukiah nine religion',
  six_pointed_star: 'six pointed star dotted purple square religion jewish hexagram dot fortune middle',
  aries: 'aries sign purple square zodiac astrology ram',
  taurus: 'taurus purple square sign zodiac astrology bull ox',
  gemini: 'gemini sign zodiac purple square astrology twins',
  cancer: 'cancer sign zodiac purple square astrology crab',
  leo: 'leo sign purple square zodiac astrology lion',
  virgo: 'virgo sign zodiac purple square astrology maiden virgin',
  libra: 'libra sign purple square zodiac astrology balance justice scales',
  scorpius: 'scorpius scorpio sign zodiac purple square astrology scorpion',
  sagittarius: 'sagittarius sign zodiac purple square astrology archer',
  capricorn: 'capricorn sign zodiac purple square astrology goat',
  aquarius: 'aquarius sign purple square zodiac astrology bearer water',
  pisces: 'pisces purple square sign zodiac astrology fish',
  ophiuchus: 'ophiuchus sign purple square constellation astrology bearer serpent snake zodiac',
  twisted_rightwards_arrows: 'twisted rightwards arrows shuffle tracks button blue square music random arrow crossed symbol merge',
  repeat: 'repeat button loop record arrow arrows circle clockwise leftwards open retweet rightwards symbol',
  repeat_one: 'repeat one single button blue square loop arrow arrows circle circled clockwise leftwards number once open overlay rightwards symbol track',
  arrow_forward: 'arrow forward play button blue square right direction black pointing triangle',
  fast_forward: 'fast forward button blue square play speed continue arrow black double pointing right symbol triangle',
  next_track_button: 'next track button forward blue square arrow bar black double pointing right scene skip symbol triangle vertical',
  play_or_pause_button: 'play or pause button blue square arrow bar black double pointing right symbol triangle vertical',
  arrow_backward: 'arrow backward reverse button blue square left direction black pointing triangle',
  rewind: 'rewind fast reverse button play blue square arrow black double left pointing symbol triangle revert',
  previous_track_button: 'previous track button last backward arrow bar black double left pointing scene skip symbol triangle vertical',
  arrow_up_small: 'arrow up small upwards button blue square triangle direction point forward top pointing red',
  arrow_double_up: 'arrow double up fast button blue square direction top black pointing triangle',
  arrow_down_small: 'arrow down small downwards button blue square direction bottom pointing red triangle',
  arrow_double_down: 'arrow double down fast button blue square direction bottom black pointing triangle',
  pause_button: 'pause button blue square bar double symbol vertical',
  stop_button: 'stop button blue square black for symbol',
  record_button: 'record button blue square black circle for symbol',
  eject_button: 'eject button blue square symbol',
  cinema: 'cinema blue square record film movie curtain stage theater activity camera entertainment movies screen symbol',
  low_brightness: 'low brightness dim button sun afternoon warm summer decrease symbol',
  high_brightness: 'high brightness bright button sun light increase symbol',
  signal_strength: 'signal strength antenna bars blue square reception phone internet connection wifi bluetooth bar cell cellular communication mobile stairs telephone',
  vibration_mode: 'vibration mode orange square phone cell communication heart mobile silent telephone',
  mobile_phone_off: 'mobile phone off mute orange square silence quiet cell communication telephone',
  female_sign: 'female sign woman women lady girl symbol venus',
  male_sign: 'male sign man boy men mars symbol',
  transgender_symbol: 'transgender symbol lgbtq female lgbt male pride sign stroke',
  heavy_multiplication_x: 'heavy multiplication x multiply sign math calculation cancel symbol',
  heavy_plus_sign: 'heavy plus sign math calculation addition more increase symbol add',
  heavy_minus_sign: 'heavy minus sign math calculation subtract less symbol remove',
  heavy_division_sign: 'heavy division sign divide math calculation symbol',
  infinity: 'infinity forever paper permanent sign unbounded universal',
  bangbang: 'bangbang double exclamation mark surprise punctuation red',
  interrobang: 'interrobang exclamation question mark wat punctuation surprise red',
  question: 'question red mark doubt confused black ornament punctuation',
  grey_question: 'grey question white mark doubts gray huh confused ornament outlined punctuation',
  grey_exclamation: 'grey exclamation white mark surprise punctuation gray wow warning ornament outlined',
  exclamation: 'exclamation red mark heavy danger surprise punctuation wow warning bang symbol',
  wavy_dash: 'wavy dash draw line moustache mustache squiggle scribble punctuation wave',
  currency_exchange: 'currency exchange money sales dollar travel bank',
  heavy_dollar_sign: 'heavy dollar sign money sales payment currency buck',
  medical_symbol: 'medical symbol health hospital aesculapius asclepius asklepios care doctor medicine rod snake staff',
  recycle: 'recycle recycling symbol arrow environment garbage trash black green logo universal reuse',
  fleur_de_lis: 'fleur de lis decorative scout new orleans saints scouts',
  trident: 'trident emblem weapon spear anchor pitchfork ship tool',
  name_badge: 'name badge fire forbid tag tofu',
  beginner: 'beginner japanese symbol for badge shield chevron green leaf mark shoshinsha tool yellow',
  o: 'o hollow red circle round correct heavy large mark',
  white_check_mark: 'white check mark button green square ok agree vote election answer tick heavy symbol pass tests',
  ballot_box_with_check: 'ballot box with check ok agree confirm black square vote election yes tick checkbox mark',
  heavy_check_mark: 'heavy check mark ok nike answer yes tick',
  x: 'x cross mark no delete remove cancel red multiplication multiply',
  negative_squared_cross_mark: 'negative squared cross mark button x green square no deny',
  curly_loop: 'curly loop scribble draw shape squiggle curl curling',
  loop: 'loop double curly tape cassette curl curling voicemail',
  part_alternation_mark: 'part alternation mark graph presentation stats business economics bad m mcdonald s',
  eight_spoked_asterisk: 'eight spoked asterisk star sparkle green square',
  eight_pointed_black_star: 'eight pointed black star orange square shape polygon',
  sparkle: 'sparkle stars green square awesome good fireworks',
  copyright: 'copyright ip license circle law legal c sign',
  registered: 'registered alphabet circle r sign',
  tm: 'tm trade mark trademark brand law legal sign',
  hash: 'hash keycap symbol blue square twitter hashtag key number octothorpe pound sign',
  asterisk: 'asterisk keycap star',
  zero: 'zero keycap 0 numbers blue square null digit',
  one: 'one keycap 1 blue square numbers digit',
  two: 'two keycap 2 numbers prime blue square digit',
  three: 'three keycap 3 numbers prime blue square digit',
  four: 'four keycap 4 numbers blue square digit',
  five: 'five keycap 5 numbers blue square prime digit',
  six: 'six keycap 6 numbers blue square digit',
  seven: 'seven keycap 7 numbers blue square prime digit',
  eight: 'eight keycap 8 blue square numbers digit',
  nine: 'nine keycap 9 blue square numbers digit',
  keycap_ten: 'keycap ten 10 numbers blue square number',
  capital_abcd: 'capital abcd input latin uppercase alphabet words blue square for symbol',
  abcd: 'abcd input latin lowercase blue square alphabet for small symbol',
  symbols: 'symbols input blue square music note ampersand percent glyphs characters for symbol',
  abc: 'abc input latin blue square alphabet for symbol',
  a: 'a button blood type red square alphabet letter capital latin negative squared',
  ab: 'ab button blood type red square alphabet negative squared',
  b: 'b button blood type red square alphabet letter capital latin negative squared',
  cl: 'cl button alphabet words red square clear sign squared',
  cool: 'cool button words blue square sign squared',
  free: 'free button blue square words sign squared',
  information_source: 'information source blue square alphabet letter i info lowercase tourist',
  id: 'id button purple square words identification identity sign squared',
  m: 'm circled alphabet blue circle letter capital latin metro',
  new: 'new button blue square words start fresh sign squared',
  ng: 'ng button blue square words shape icon blooper good no sign squared',
  o2: 'o2 o button blood type alphabet red square letter capital latin negative squared',
  ok: 'ok button good agree yes blue square okay sign squared',
  parking: 'parking p button cars blue square alphabet letter capital latin negative sign squared',
  sos: 'sos button help red square words emergency 911 distress sign signal squared',
  up: 'up button blue square above high exclamation level mark sign squared',
  vs: 'vs button words orange square squared versus',
  koko: 'koko japanese here button blue square katakana destination meaning sign squared word',
  sa: 'sa japanese service charge button blue square katakana meaning or sign squared',
  u6708: 'u6708 japanese monthly amount button chinese month moon orange square kanji cjk ideograph meaning radical sign squared unified',
  u6709: 'u6709 japanese not free of charge button orange square chinese have kanji cjk exist ideograph meaning own sign squared unified',
  u6307: 'u6307 japanese reserved button chinese point green square kanji cjk finger ideograph meaning sign squared unified',
  ideograph_advantage: 'ideograph advantage japanese bargain button chinese kanji obtain get circle acquire circled meaning sign',
  u5272: 'u5272 japanese discount button cut divide chinese kanji pink square bargain cjk ideograph meaning sale sign squared unified',
  u7121: 'u7121 japanese free of charge button nothing chinese kanji orange square cjk ideograph lacking meaning negation sign squared unified',
  u7981: 'u7981 japanese prohibited button kanji chinese forbidden limit restricted red square cjk forbid ideograph meaning prohibit sign squared unified',
  accept: 'accept japanese acceptable button ok good chinese kanji agree yes orange circle circled ideograph meaning sign',
  u7533: 'u7533 japanese application button chinese kanji orange square apply cjk form ideograph meaning monkey request sign squared unified',
  u5408: 'u5408 japanese passing grade button chinese join kanji red square agreement cjk ideograph meaning sign squared together unified',
  u7a7a: 'u7a7a japanese vacancy button kanji chinese empty sky blue square 7a7a available cjk ideograph meaning sign squared unified',
  congratulations: 'congratulations japanese button chinese kanji red circle circled congratulate congratulation ideograph meaning sign',
  secret: 'secret japanese button privacy chinese sshh kanji red circle circled ideograph meaning sign',
  u55b6: 'u55b6 japanese open for business button opening hours orange square 55b6 chinese cjk ideograph meaning operating sign squared unified work',
  u6e80: 'u6e80 japanese no vacancy button full chinese red square kanji 6e80 cjk fullness ideograph meaning sign squared unified',
  red_circle: 'red circle shape error danger geometric large',
  orange_circle: 'orange circle round geometric large',
  yellow_circle: 'yellow circle round geometric large',
  green_circle: 'green circle round geometric large',
  large_blue_circle: 'large blue circle shape icon button geometric',
  purple_circle: 'purple circle round geometric large',
  brown_circle: 'brown circle round geometric large',
  black_circle: 'black circle shape button round geometric medium',
  white_circle: 'white circle shape round geometric medium',
  red_square: 'red square card geometric large',
  orange_square: 'orange square geometric large',
  yellow_square: 'yellow square card geometric large',
  green_square: 'green square geometric large',
  blue_square: 'blue square geometric large',
  purple_square: 'purple square geometric large',
  brown_square: 'brown square geometric large',
  black_large_square: 'black large square shape icon button geometric',
  white_large_square: 'white large square shape icon stone button geometric',
  black_medium_square: 'black medium square shape button icon geometric',
  white_medium_square: 'white medium square shape stone icon geometric',
  black_medium_small_square: 'black medium small square icon shape button geometric',
  white_medium_small_square: 'white medium small square shape stone icon button geometric',
  black_small_square: 'black small square shape icon geometric',
  white_small_square: 'white small square shape icon geometric',
  large_orange_diamond: 'large orange diamond shape jewel gem geometric',
  large_blue_diamond: 'large blue diamond shape jewel gem geometric',
  small_orange_diamond: 'small orange diamond shape jewel gem geometric',
  small_blue_diamond: 'small blue diamond shape jewel gem geometric',
  small_red_triangle: 'small red triangle pointed up shape direction top geometric pointing',
  small_red_triangle_down: 'small red triangle down pointed shape direction bottom geometric pointing',
  diamond_shape_with_a_dot_inside: 'diamond shape with a dot inside jewel blue gem crystal fancy comic cuteness flower geometric kawaii',
  radio_button: 'radio button input old music circle geometric',
  white_square_button: 'white square button shape input geometric outlined',
  black_square_button: 'black square button shape input frame geometric',
  heavy_equals_sign: 'heavy equals sign math equality',
  khanda: 'khanda sikhism religion',
  wireless: 'wireless wifi internet contactless signal',
  checkered_flag: 'checkered flag chequered contest finishline race gokart finish girl grid milestone racing',
  triangular_flag_on_post: 'triangular flag on post mark milestone place pole red',
  crossed_flags: 'crossed flags japanese nation country border activity celebration cross flag two',
  black_flag: 'black flag pirate waving',
  white_flag: 'white flag losing loser lost surrender give up fail waving',
  rainbow_flag: 'rainbow flag pride gay lgbt queer homosexual lesbian bisexual',
  transgender_flag: 'transgender flag pride lgbtq blue lgbt light pink trans white',
  pirate_flag: 'pirate flag skull crossbones banner jolly plunder roger treasure',
  ascension_island: 'ascension island flag',
  andorra: 'andorra flag ad nation country banner andorran',
  united_arab_emirates: 'united arab emirates flag nation country banner emirati uae',
  afghanistan: 'afghanistan flag af nation country banner afghan',
  antigua_barbuda: 'antigua barbuda flag nation country banner',
  anguilla: 'anguilla flag ai nation country banner anguillan',
  albania: 'albania flag al nation country banner albanian',
  armenia: 'armenia flag am nation country banner armenian',
  angola: 'angola flag ao nation country banner angolan',
  antarctica: 'antarctica flag aq nation country banner antarctic',
  argentina: 'argentina flag ar nation country banner argentinian',
  american_samoa: 'american samoa flag ws nation country banner samoan',
  austria: 'austria flag at nation country banner austrian',
  australia: 'australia flag au nation country banner aussie australian heard mcdonald',
  aruba: 'aruba flag aw nation country banner aruban',
  aland_islands: 'aland islands flag land nation country banner',
  azerbaijan: 'azerbaijan flag az nation country banner azerbaijani',
  bosnia_herzegovina: 'bosnia herzegovina flag nation country banner',
  barbados: 'barbados flag bb nation country banner bajan barbadian',
  bangladesh: 'bangladesh flag bd nation country banner bangladeshi',
  belgium: 'belgium flag be nation country banner belgian',
  burkina_faso: 'burkina faso flag nation country banner burkinabe',
  bulgaria: 'bulgaria flag bg nation country banner bulgarian',
  bahrain: 'bahrain flag bh nation country banner bahrainian bahrani',
  burundi: 'burundi flag bi nation country banner burundian',
  benin: 'benin flag bj nation country banner beninese',
  st_barthelemy: 'st barthelemy flag barth lemy saint nation country banner',
  bermuda: 'bermuda flag bm nation country banner bermudan',
  brunei: 'brunei flag bn darussalam nation country banner bruneian',
  bolivia: 'bolivia flag bo nation country banner bolivian',
  caribbean_netherlands: 'caribbean netherlands flag bonaire nation country banner eustatius saba sint',
  brazil: 'brazil flag br nation country banner brasil brazilian for',
  bahamas: 'bahamas flag bs nation country banner bahamian',
  bhutan: 'bhutan flag bt nation country banner bhutanese',
  bouvet_island: 'bouvet island flag norway',
  botswana: 'botswana flag bw nation country banner batswana',
  belarus: 'belarus flag by nation country banner belarusian',
  belize: 'belize flag bz nation country banner belizean',
  canada: 'canada flag ca nation country banner canadian',
  cocos_islands: 'cocos islands flag keeling nation country banner island',
  congo_kinshasa: 'congo kinshasa flag democratic republic nation country banner drc',
  central_african_republic: 'central african republic flag nation country banner',
  congo_brazzaville: 'congo brazzaville flag nation country banner republic',
  switzerland: 'switzerland flag ch nation country banner cross red swiss',
  cote_divoire: 'cote divoire flag c te d ivoire ivory coast nation country banner',
  cook_islands: 'cook islands flag nation country banner island islander',
  chile: 'chile flag nation country banner chilean',
  cameroon: 'cameroon flag cm nation country banner cameroonian',
  cn: 'cn flag china chinese prc country nation banner symbol',
  colombia: 'colombia flag co nation country banner colombian',
  clipperton_island: 'clipperton island flag',
  costa_rica: 'costa rica flag nation country banner rican',
  cuba: 'cuba flag cu nation country banner cuban',
  cape_verde: 'cape verde flag cabo nation country banner verdian',
  curacao: 'curacao flag cura ao nation country banner antilles aoan',
  christmas_island: 'christmas island flag nation country banner',
  cyprus: 'cyprus flag cy nation country banner cypriot',
  czech_republic: 'czech republic flag czechia cz nation country banner',
  de: 'de flag germany german nation country banner deutsch symbol',
  diego_garcia: 'diego garcia flag',
  djibouti: 'djibouti flag dj nation country banner djiboutian',
  denmark: 'denmark flag dk nation country banner danish',
  dominica: 'dominica flag dm nation country banner',
  dominican_republic: 'dominican republic flag nation country banner dom rep',
  algeria: 'algeria flag dz nation country banner algerian',
  ceuta_melilla: 'ceuta melilla flag',
  ecuador: 'ecuador flag ec nation country banner ecuadorian',
  estonia: 'estonia flag ee nation country banner estonian',
  egypt: 'egypt flag eg nation country banner egyptian',
  western_sahara: 'western sahara flag nation country banner saharan west',
  eritrea: 'eritrea flag er nation country banner eritrean',
  es: 'es flag spain nation country banner ceuta melilla spanish symbol',
  ethiopia: 'ethiopia flag et nation country banner ethiopian',
  eu: 'eu flag european union banner',
  finland: 'finland flag fi nation country banner finnish',
  fiji: 'fiji flag fj nation country banner fijian',
  falkland_islands: 'falkland islands flag malvinas nation country banner falklander falklands island islas',
  micronesia: 'micronesia flag federated states nation country banner micronesian',
  faroe_islands: 'faroe islands flag nation country banner island islander',
  fr: 'fr flag france banner nation french country clipperton island martin saint st symbol',
  gabon: 'gabon flag ga nation country banner gabonese',
  gb: 'gb flag united kingdom great britain northern ireland nation country banner british uk english england union jack cornwall scotland wales',
  grenada: 'grenada flag gd nation country banner grenadian',
  georgia: 'georgia flag ge nation country banner georgian',
  french_guiana: 'french guiana flag nation country banner guinean',
  guernsey: 'guernsey flag gg nation country banner',
  ghana: 'ghana flag gh nation country banner ghanaian',
  gibraltar: 'gibraltar flag gi nation country banner gibraltarian',
  greenland: 'greenland flag gl nation country banner greenlandic',
  gambia: 'gambia flag gm nation country banner gambian',
  guinea: 'guinea flag gn nation country banner guinean',
  guadeloupe: 'guadeloupe flag gp nation country banner guadeloupean',
  equatorial_guinea: 'equatorial guinea flag gn nation country banner equatoguinean guinean',
  greece: 'greece flag gr nation country banner greek',
  south_georgia_south_sandwich_islands: 'south georgia sandwich islands flag nation country banner island',
  guatemala: 'guatemala flag gt nation country banner guatemalan',
  guam: 'guam flag gu nation country banner chamorro guamanian',
  guinea_bissau: 'guinea bissau flag gw nation country banner',
  guyana: 'guyana flag gy nation country banner guyanese',
  hong_kong: 'hong kong flag sar china nation country banner',
  heard_mcdonald_islands: 'heard mcdonald islands flag mc donald',
  honduras: 'honduras flag hn nation country banner honduran',
  croatia: 'croatia flag hr nation country banner croatian',
  haiti: 'haiti flag ht nation country banner haitian',
  hungary: 'hungary flag hu nation country banner hungarian',
  canary_islands: 'canary islands flag nation country banner island',
  indonesia: 'indonesia flag nation country banner indonesian',
  ireland: 'ireland flag ie nation country banner irish',
  israel: 'israel flag il nation country banner israeli',
  isle_of_man: 'isle of man flag nation country banner manx',
  india: 'india flag in nation country banner indian',
  british_indian_ocean_territory: 'british indian ocean territory flag nation country banner chagos diego garcia island',
  iraq: 'iraq flag iq nation country banner iraqi',
  iran: 'iran flag islamic republic nation country banner iranian',
  iceland: 'iceland flag is nation country banner icelandic',
  it: 'it flag italy nation country banner italian symbol',
  jersey: 'jersey flag je nation country banner',
  jamaica: 'jamaica flag jm nation country banner jamaican',
  jordan: 'jordan flag jo nation country banner jordanian',
  jp: 'jp flag japan japanese nation country banner ja symbol',
  kenya: 'kenya flag ke nation country banner kenyan',
  kyrgyzstan: 'kyrgyzstan flag kg nation country banner kyrgyzstani',
  cambodia: 'cambodia flag kh nation country banner cambodian',
  kiribati: 'kiribati flag ki nation country banner i',
  comoros: 'comoros flag km nation country banner comoran',
  st_kitts_nevis: 'st kitts nevis flag saint nation country banner',
  north_korea: 'north korea flag nation country banner korean',
  kr: 'kr flag south korea nation country banner korean symbol',
  kuwait: 'kuwait flag kw nation country banner kuwaiti',
  cayman_islands: 'cayman islands flag nation country banner caymanian island',
  kazakhstan: 'kazakhstan flag kz nation country banner kazakh kazakhstani',
  laos: 'laos flag lao democratic republic nation country banner laotian',
  lebanon: 'lebanon flag lb nation country banner lebanese',
  st_lucia: 'st lucia flag saint nation country banner',
  liechtenstein: 'liechtenstein flag li nation country banner liechtensteiner',
  sri_lanka: 'sri lanka flag nation country banner lankan',
  liberia: 'liberia flag lr nation country banner liberian',
  lesotho: 'lesotho flag ls nation country banner basotho',
  lithuania: 'lithuania flag lt nation country banner lithuanian',
  luxembourg: 'luxembourg flag lu nation country banner luxembourger',
  latvia: 'latvia flag lv nation country banner latvian',
  libya: 'libya flag ly nation country banner libyan',
  morocco: 'morocco flag ma nation country banner moroccan',
  monaco: 'monaco flag mc nation country banner mon gasque',
  moldova: 'moldova flag republic nation country banner moldovan',
  montenegro: 'montenegro flag me nation country banner montenegrin',
  st_martin: 'st martin flag',
  madagascar: 'madagascar flag mg nation country banner madagascan',
  marshall_islands: 'marshall islands flag nation country banner island marshallese',
  macedonia: 'macedonia flag north nation country banner macedonian',
  mali: 'mali flag ml nation country banner malian',
  myanmar: 'myanmar flag burma mm nation country banner burmese for myanmarese',
  mongolia: 'mongolia flag mn nation country banner mongolian',
  macau: 'macau flag macao sar china nation country banner macanese',
  northern_mariana_islands: 'northern mariana islands flag nation country banner island micronesian north',
  martinique: 'martinique flag mq nation country banner martiniquais of snake',
  mauritania: 'mauritania flag mr nation country banner mauritanian',
  montserrat: 'montserrat flag ms nation country banner montserratian',
  malta: 'malta flag mt nation country banner maltese',
  mauritius: 'mauritius flag mu nation country banner mauritian',
  maldives: 'maldives flag mv nation country banner maldivian',
  malawi: 'malawi flag mw nation country banner malawian',
  mexico: 'mexico flag mx nation country banner mexican',
  malaysia: 'malaysia flag my nation country banner malaysian',
  mozambique: 'mozambique flag mz nation country banner mozambican',
  namibia: 'namibia flag na nation country banner namibian',
  new_caledonia: 'new caledonia flag nation country banner caledonian',
  niger: 'niger flag ne nation country banner nigerien',
  norfolk_island: 'norfolk island flag nation country banner',
  nigeria: 'nigeria flag nation country banner nigerian',
  nicaragua: 'nicaragua flag ni nation country banner nicaraguan',
  netherlands: 'netherlands flag nl nation country banner dutch',
  norway: 'norway flag no nation country banner bouvet jan mayen norwegian svalbard',
  nepal: 'nepal flag np nation country banner nepalese',
  nauru: 'nauru flag nr nation country banner nauruan',
  niue: 'niue flag nu nation country banner niuean',
  new_zealand: 'new zealand flag nation country banner kiwi',
  oman: 'oman flag om symbol nation country banner omani',
  panama: 'panama flag pa nation country banner panamanian',
  peru: 'peru flag pe nation country banner peruvian',
  french_polynesia: 'french polynesia flag nation country banner polynesian',
  papua_new_guinea: 'papua new guinea flag nation country banner guinean png',
  philippines: 'philippines flag ph nation country banner',
  pakistan: 'pakistan flag pk nation country banner pakistani',
  poland: 'poland flag pl nation country banner polish',
  st_pierre_miquelon: 'st pierre miquelon flag saint nation country banner',
  pitcairn_islands: 'pitcairn islands flag nation country banner island',
  puerto_rico: 'puerto rico flag nation country banner rican',
  palestinian_territories: 'palestinian territories flag palestine nation country banner',
  portugal: 'portugal flag pt nation country banner portugese',
  palau: 'palau flag pw nation country banner palauan',
  paraguay: 'paraguay flag py nation country banner paraguayan',
  qatar: 'qatar flag qa nation country banner qatari',
  reunion: 'reunion flag r union nation country banner unionnais',
  romania: 'romania flag ro nation country banner romanian',
  serbia: 'serbia flag rs nation country banner serbian',
  ru: 'ru flag russia russian federation nation country banner symbol',
  rwanda: 'rwanda flag rw nation country banner rwandan',
  saudi_arabia: 'saudi arabia flag nation country banner arabian',
  solomon_islands: 'solomon islands flag nation country banner island islander',
  seychelles: 'seychelles flag sc nation country banner seychellois',
  sudan: 'sudan flag sd nation country banner sudanese',
  sweden: 'sweden flag se nation country banner swedish',
  singapore: 'singapore flag sg nation country banner singaporean',
  st_helena: 'st helena flag saint ascension tristan cunha nation country banner',
  slovenia: 'slovenia flag si nation country banner slovenian',
  svalbard_jan_mayen: 'svalbard jan mayen flag',
  slovakia: 'slovakia flag sk nation country banner slovakian slovak',
  sierra_leone: 'sierra leone flag nation country banner leonean',
  san_marino: 'san marino flag nation country banner sammarinese',
  senegal: 'senegal flag sn nation country banner sengalese',
  somalia: 'somalia flag so nation country banner somalian',
  suriname: 'suriname flag sr nation country banner surinamer',
  south_sudan: 'south sudan flag sd nation country banner sudanese',
  sao_tome_principe: 'sao tome principe flag s o tom pr ncipe nation country banner',
  el_salvador: 'el salvador flag nation country banner salvadoran',
  sint_maarten: 'sint maarten flag dutch nation country banner',
  syria: 'syria flag syrian arab republic nation country banner',
  swaziland: 'swaziland flag eswatini sz nation country banner',
  tristan_da_cunha: 'tristan da cunha flag',
  turks_caicos_islands: 'turks caicos islands flag nation country banner island',
  chad: 'chad flag td nation country banner chadian',
  french_southern_territories: 'french southern territories flag nation country banner antarctic lands',
  togo: 'togo flag tg nation country banner togolese',
  thailand: 'thailand flag th nation country banner thai',
  tajikistan: 'tajikistan flag tj nation country banner tajik',
  tokelau: 'tokelau flag tk nation country banner tokelauan',
  timor_leste: 'timor leste flag nation country banner east timorese',
  turkmenistan: 'turkmenistan flag nation country banner turkmen',
  tunisia: 'tunisia flag tn nation country banner tunisian',
  tonga: 'tonga flag to nation country banner tongan',
  tr: 'tr flag t rkiye turkey nation country banner turkish',
  trinidad_tobago: 'trinidad tobago flag nation country banner',
  tuvalu: 'tuvalu flag nation country banner tuvaluan',
  taiwan: 'taiwan flag tw nation country banner china taiwanese',
  tanzania: 'tanzania flag united republic nation country banner tanzanian',
  ukraine: 'ukraine flag ua nation country banner ukrainian',
  uganda: 'uganda flag ug nation country banner ugandan',
  us_outlying_islands: 'us outlying islands flag u s',
  united_nations: 'united nations flag un banner',
  us: 'us flag united states america nation country banner american islands outlying symbol usa',
  uruguay: 'uruguay flag uy nation country banner uruguayan',
  uzbekistan: 'uzbekistan flag uz nation country banner uzbek uzbekistani',
  vatican_city: 'vatican city flag nation country banner vanticanien',
  st_vincent_grenadines: 'st vincent grenadines flag saint nation country banner',
  venezuela: 'venezuela flag ve bolivarian republic nation country banner venezuelan',
  british_virgin_islands: 'british virgin islands flag bvi nation country banner island islander',
  us_virgin_islands: 'us virgin islands flag u s nation country banner america island islander states united usa',
  vietnam: 'vietnam flag viet nam nation country banner vietnamese',
  vanuatu: 'vanuatu flag vu nation country banner ni',
  wallis_futuna: 'wallis futuna flag nation country banner',
  samoa: 'samoa flag ws nation country banner samoan',
  kosovo: 'kosovo flag xk nation country banner kosovar',
  yemen: 'yemen flag ye nation country banner yemeni',
  mayotte: 'mayotte flag yt nation country banner',
  south_africa: 'south africa flag nation country banner african',
  zambia: 'zambia flag zm nation country banner zambian',
  zimbabwe: 'zimbabwe flag zw nation country banner zim zimbabwean',
  england: 'england flag english cross george s st',
  scotland: 'scotland flag scottish andrew s cross saltire st',
  wales: 'wales flag welsh baner cymru ddraig dragon goch red y',
};
